import asyncActionTypes from './types.js';
import { actionableCodes } from '../../scripts/components/error-handling/error-codes';
import { get } from 'lodash';
import { getCMSUrl } from '../../scripts/constants/cms-urls';
import { ENROLLMENT_ABORT_ERRORS } from '../../scripts/constants/user-profile.js';
import { handleError } from './errorHelper';

import {
  changeItinerary,
  deleteSession,
  ffnAssociation,
  getAmGrant,
  getAncillaries,
  getBenefitsCoreApi,
  getBearerTokenContactability,
  getEMDVoucherCompensation,
  getFormsOfPayment,
  getIropEligibility,
  getPnr,
  getPreselectSeats,
  getPriceChubb,
  getSeatMap,
  getUserSessionTM,
  getSessionStatus,
  otpSettings,
  postMealsSelected,
  postPrioritylist,
  postRecoverAccount,
  putFFNumberMicro,
  putShopingCart,
  retrieveProfileUserSession,
  retrieveUpgradeVoucher,
  retrieveUserCampingEnrolled,
  saveContactabilityDigital,
  sendAncillaryRejectEvent,
  sendEmailItineraryPnrRequest,
  sendRefundInfoToSalesforceApi,
  streamAmaiaResponse,
  submitPayment,
  submitRemoveEmdVoucher,
  submitUpgradeVouchers,
  submitUserResendOTPLogin,
  submitValidateEmdVoucher,
  updateConsentCp,
  userProfileIsValidCPSession,
  userProfileRegistrationEmailValidation,
  userProfileRegistrationTutorValidation,
  userProfileSendOtp,
  userProfileSignIn,
  userProfileSignOut,
  userProfileSignUp,
  getBalance,
  getSingleBilling,
  getStampingBilling,
  getCheckInReservation,
} from '../../api-wrapper/api';

import transformAssociationFFnumber from '../../api-wrapper/transformers/association-ffnumber.js';

import {
  getAirportsLite,
  getAmaiaFaq,
  getBannerCobrandAffiliate,
  getBrandedBenefits,
  getControlPanelCMS,
  getDestinationInfo,
  getErrorMessageCMS,
  getInfoSignUpPopUp,
  getInfoTouchPoints,
  getLanguageBundle,
  getMealPreselectFlights,
  getMenuPromotionsCMS,
  getPersonalizedAcquisitionCobrand,
  getRefundReason,
  getStoreFronts,
  getTravelInformationCMS,
  getWebValidations,
} from '../../cms-wrapper/cms';
import { normalizeStorefronts, getErrorCodeLanguageBundle, getNumberOfDecimalsBE } from '../../cms-wrapper/utils';
import {
  REMOVE_ANCILLARY_FROM_TRAVELERS,
  REMOVE_ANCILLARY_PI_FROM_TRAVELERS,
  DEEP_LINK_ANCILLARY,
  ADD_FREQUENT_FLYER_NUMBER,
  DEEP_LINK_SEATS,
  WAS_ON_HOLD,
  RELOAD_BAGGAGE_FLAG,
  INITIAL_CONFIRMATION_MODEL,
  ACTIVATE_PERSISTENT_LOGIN_POPUP,
  DISABLE_PERSISTENT_LOGIN_POPUP,
  RESET_CP_NUMBER,
  RESET_LOGIN_SUCCESS_COUNT,
  SET_SIGN_IN_STATE,
  UPDATE_STATE_FARE_LOCK,
} from '../constants/action-types';
import {
  userSignOutClassOpts,
  userSignInClassOpts,
} from '../../scripts/utilities/profile-class-request';
import { changeItineraryClassOpts } from '../../scripts/utilities/schedule-change-class-request';

import {
  handleDisconnectModal,
} from '../actions/baggageRedemption';

import upgradeVoucherCreators from './upgrade-voucher-creators.js';

import {
  getInitials,
  getUserFirstName,
  formatUserSessionCookie,
} from '../../scripts/utilities/helpers';
import errorTrackingFromCMS from '../../scripts/analytics/creators/error';
import errorTracking from '../../scripts/analytics/creators/manage';
import { sendAnalytics } from '../../scripts/analytics/tracker';
import manageTracking from '../../scripts/analytics/creators/manage';
import formFieldCopyIDs from '../../scripts/constants/form-field-copy-ids.js';
import storage from '../../scripts/utilities/storage-manager';
import { Home } from '../../routing/urls';
import { activeBannerUpdateConsent } from './profile-action-creators';
import seatsTracking from '../../scripts/analytics/creators/seat';
import { ACTION_LOGIN } from './Interaction-studio-action-creators.js';
import { fetchIp } from '../../scripts/utilities/ipAddress';
import { getCmsErrorUpgradeVoucher } from '../../scripts/utilities/upgrade-vouchers.js';
import { upgradeVoucherErrors } from '../../scripts/constants/upgrade-voucher-codes.js';
import { getActionableByCode } from '../../scripts/utilities/error-codes.js';
import safeLocalStorage from '../../scripts/utilities/safe-local-storage';

export function retrieveStoreFront(language, country) {
  return function action(dispatch) {
    const request = getStoreFronts();
    dispatch(addStoreFrontsStart());
    return request.then(response => {
      if (response.error) {
        const statusCode = response.error.response && response.error.response.status ? response.error.response.status : 503;
        const urlErrorEndpoint = response.error.request && response.error.request.responseURL ? response.error.request.responseURL : null;
        handleError(dispatch, response.error, {
          statusCode,
          code: '13110918',
          actionable: 'ABORT',
          actionType: 'RETRIEVE_STOREFRONT_CONFIG',
          errorMsg: response.error.message ? `${response.error.message} ${urlErrorEndpoint}` : `CMS_SERVICE_UNAVAILABLE ${urlErrorEndpoint}`,
          errorExtraInfo: response.error.stack ? response.error.stack : 'Service Unavailable from CMS, please try again some minutes later',
          failAction: addStoreFrontsFail,
        });
      } else {
        // Se encadena la config y se espera a que th-web-validations RESPONDA antes de
        // levantar el loading. Así, cuando la app avanza y llama a los microservicios:
        //  - si la respuesta trajo la bandera, ya está en Redux y se envía en los headers;
        //  - si no la trajo (o el servicio falló), se llaman igual sin la bandera.
        // Lo importante es esperar la respuesta del servicio, no que la bandera exista.
        return dispatch(retrieveStoreFrontConfig(language, country, response.storefronts));
      }
    }).catch(error => {
      const urlErrorEndpoint = error.request && error.request.responseURL ? error.request.responseURL : null;
      handleError(dispatch, error, {
        type: 'Fatal',
        statusCode: 503,
        code: '13110918',
        actionable: 'ABORT',
        actionType: 'RETRIEVE_STOREFRONT_CONFIG',
        errorMsg: error.message ? `${error.message} ${urlErrorEndpoint}` : `CMS_SERVICE_UNAVAILABLE ${urlErrorEndpoint}`,
        errorExtraInfo: error.stack ? error.stack : 'Service Unavailable from CMS, please try again some minutes later',
        failAction: addStoreFrontsFail,
      });
    });
  };
}

export const sendAmaiaMessageAction = (userPrompt) => (dispatch, getState) => {
  dispatch({ type: asyncActionTypes.SEARCH_AMAIA.START });
  const getSessionId = () => {
    // Normalización de ID de sesión para compatibilidad legacy.
    const stored = localStorage.getItem('gist.web.sessionId');
    try {
      const parsed = JSON.parse(stored);
      return parsed?.value || stored;
    } catch {
      return stored;
    }
  };

  const finalSessionId = getSessionId();
  const { country, language } = getState().Manage;
  const context = {
    currency: 'MXN',
    language: language || 'es',
    region: country || 'mx',
    'user_time_zone': Intl.DateTimeFormat().resolvedOptions().timeZone,
  };
  return streamAmaiaResponse(
    userPrompt,
    finalSessionId,
    context,
    // Dispatch de fragmentos para animación de escritura.
    (chunk) => dispatch({ payload: chunk, type: asyncActionTypes.SEARCH_AMAIA_CHUNK.START }),
    (error) => {
      // Manejo de error: dispara FAIL para que el componente muestre el mensaje traducido
      dispatch({ payload: error, type: asyncActionTypes.SEARCH_AMAIA.FAIL });
    },
    () => dispatch({ type: asyncActionTypes.SEARCH_AMAIA.SUCCESS })
  );
};

export function retrieveAmaiaFaq(storefront, status) {
  return async function action(dispatch) {
    dispatch(retrieveAmaiaFaqStart());
    try {
      const response = await getAmaiaFaq(storefront, status);
      if (response.error) {
        dispatch(retrieveAmaiaFaqFail(response.error));
      } else {
        dispatch(retrieveAmaiaFaqSuccess(response));
      }
    } catch (error) {
      dispatch(retrieveAmaiaFaqFail(error));
    }
  };
}

export const retrieveAmaiaFaqStart = () => ({ type: asyncActionTypes.RETRIEVE_AMAIA_FAQ.START });
export const retrieveAmaiaFaqSuccess = (response) => ({ payload: response, type: asyncActionTypes.RETRIEVE_AMAIA_FAQ.SUCCESS });
export const retrieveAmaiaFaqFail = (error) => ({ payload: error, type: asyncActionTypes.RETRIEVE_AMAIA_FAQ.FAIL });

export const addStoreFrontsStart = () => ({
  type: asyncActionTypes.STORE_FRONTS.START,
});

export const addStoreFronts = storeFront => ({
  type: asyncActionTypes.STORE_FRONTS.SUCCESS,
  payload: { 'response': storeFront },
});

export const addStoreFrontsFail = (error) => ({
  type: asyncActionTypes.STORE_FRONTS.FAIL,
  payload: { 'response': error },
});

export function retrieveStoreFrontConfig(language, country, storefronts) {
  return async function action(dispatch) {
    const dataStoreFronts = normalizeStorefronts(storefronts);
    const data = {
      dataStoreFronts,
      language: language,
      country: country,
    };

    // numberOfDecimalsBE ahora se consume del servicio th-web-validations (ya no del storefront CMS).
    // Se inyecta dentro del storefront seleccionado para que los consumidores sigan leyendo
    // state.Manage.stateStoreFront.numberOfDecimalsBE sin cambios.
    const selectedStorefront = dataStoreFronts?.[country]?.[language];
    if (selectedStorefront) {
      const storefrontId = selectedStorefront.storefrontId;
      try {
        const webValidations = await getWebValidations(storefrontId);
        const decimals = getNumberOfDecimalsBE(webValidations);
        // Solo se guarda si la bandera realmente llegó. Si no llega, se deja ausente
        // para no propagarla a los microservicios (no se envía en headers).
        if (decimals !== undefined) {
          selectedStorefront.numberOfDecimalsBE = decimals;
        }
      } catch (error) {
        // Si el servicio de validaciones falla, la bandera queda ausente y no se propaga.
      }
    }

    dispatch(addStateStoreFronts(data));
    dispatch(addStoreFronts(storefronts));
  };
}

export function retrieveLanguageBundle(language, storeFront, country) {
  return function action(dispatch) {
    const endpointList = [
      `/language-checkin?bundle=INIT&language=${language}&status=1`,
      `/language-myb?bundle=INIT&language=${language}&status=1`,
      `/language-cyc?bundle=INIT&language=${language}&status=1`,
      `/language-profile?bundle=INIT&language=${language}&status=1`,
      `/language-booking?bundle=INIT&language=${language}&status=1`,
      `/language-global?bundle=INIT&language=${language}&status=1`,
    ];
    let contDispatch = 0;
    let cacheLanguageBundle = {};
    const cacheLanguage = storage.get('mybLanguage') ? storage.get('mybLanguage') : null;
    let hasError = false;
    if (!storage.get('mybLanguageBundleCMS') || (cacheLanguage && cacheLanguage !== language)) {
      endpointList.forEach(endpoint => {
        if (!hasError) {
          dispatch(addLanguageBundleStart(endpointList.length));
          const request = getLanguageBundle(endpoint);
          request.then(response => {
            if (response.error) {
              hasError = true;
              dispatch(addLanguageBundleFail(response.error));
              const requestUrl = response.error.request && response.error.request.responseURL ? response.error.request.responseURL : 'global';
              const errorCode = getErrorCodeLanguageBundle(requestUrl);
              const statusCode = response.error.response && response.error.response.status ? response.error.response.status : 503;
              const urlErrorEndpoint = response.error.request && response.error.request.responseURL ? response.error.request.responseURL : null;
              dispatch(sendAnalytics({
                eventCreator: errorTrackingFromCMS.errorFromCMS({
                  'type': 'Fatal',
                  'statusCode': statusCode,
                  'code': `${errorCode}`,
                  'actionable': 'ABORT',
                  'actionType': 'RETRIEVE_MULTIPLE_LANGUAGE_BUNDLES',
                  'errorMsg': response.error.message ? `${response.error.message} ${urlErrorEndpoint}` : `CMS_SERVICE_UNAVAILABLE ${urlErrorEndpoint}`,
                  'errorExtraInfo': response.error.stack ? response.error.stack : 'Service Unavailable from CMS, please try again some minutes later',
                }),
              }));
            } else {
              contDispatch += 1;
              dispatch(addLanguageBundle(response, language, storeFront, country, contDispatch));
            }
          }).catch(error => {
            const urlErrorEndpoint = error.request && error.request.responseURL ? error.request.responseURL : null;
            hasError = true;
            dispatch(addLanguageBundleFail(error));
            dispatch(sendAnalytics({
              eventCreator: errorTrackingFromCMS.errorFromCMS({
                'type': 'Fatal',
                'statusCode': 503,
                'code': '17110901',
                'actionable': 'ABORT',
                'actionType': 'RETRIEVE_LANGUAGE_BUNDLE',
                'errorMsg': error.message ? `${error.message} ${urlErrorEndpoint}` : `CMS_SERVICE_UNAVAILABLE ${urlErrorEndpoint}`,
                'errorExtraInfo': error.stack ? error.stack : 'Service Unavailable from CMS, please try again some minutes later',
              }),
            }));
          });
        }
      });
    } else {
      cacheLanguageBundle = storage.get('mybLanguageBundleCMS');
      dispatch(addLanguageBundleCache(cacheLanguageBundle, language, storeFront, country));
    }
  };
}

export const addLanguageBundleStart = (numEndpoints) => ({
  type: asyncActionTypes.LANGUAGE_BUNDLE.START,
  payload: { numEndpoints: numEndpoints },
});

export const addLanguageBundle = (response, language, storeFront, country, cont) => ({
  type: asyncActionTypes.LANGUAGE_BUNDLE.SUCCESS,
  payload: {
    language: language,
    storeFront: storeFront,
    country: country,
    cont: cont,
    response: response,
  },
});

export const addLanguageBundleFail = (error) => ({
  type: asyncActionTypes.LANGUAGE_BUNDLE.FAIL,
  payload: {
    'error': error,
  },
});

export const addLanguageBundleCache = (cacheLanguageBundle, language, storeFront, country) => ({
  type: asyncActionTypes.LANGUAGE_BUNDLE_CACHE.SUCCESS,
  payload: {
    cacheLanguageBundle: cacheLanguageBundle,
    language: language,
    storeFront: storeFront,
    country: country,
  },
});

export function setStoreFront(storefront) {
  return function action(dispatch) {
    storefront = storefront === '' ? 'es-mx' : storefront;
    dispatch(setStateStoreFront(storefront));
  };
}

export function setLanguage(language) {
  return function action(dispatch) {
    language = language === '' ? 'es' : language;
    dispatch(setStateLanguage(language));
  };
}

export function incidentTracking(response, actionType, dispatch) {
  const recategorizedActionable = getActionableByCode(response.code, response.actionable);
  const errorInfo = {
    errorData: {
      actionable: recategorizedActionable,
      msg: response.msg,
      extraInfo: {
        'debugging_stuff_here': response?.extraInfo?.debugging_stuff_here || null,
      },
    },
  };

  if (response?.code === '13334001') {
    dispatch(sendAnalytics({
      eventCreator: manageTracking.errorChubbPrices(errorInfo, parseInt(response.code, 10), response?.status, actionType.START),
    }));
  }

  if (response?.code !== '13330701' && response?.code !== '13430701' && response?.code !== '13334001') {
    dispatch(sendAnalytics({
      eventCreator: manageTracking.errorApiServiceTracking(errorInfo, parseInt(response.code, 10), response.status, actionType.START),
    }));
  }
}

export function incidentApiGeeTracking(response, actionType, endpoint, dispatch) {
  const endpointNormalized = endpoint ? endpoint : '';

  const errorInfo = {
    errorData: {
      actionable: response.actionable,
      msg: 'API_SERVICE_UNAVAILABLE',
      extraInfo: {
        'debugging_stuff_here': 'Error endpoint ' + endpointNormalized,
      },
    },
  };
  dispatch(sendAnalytics({
    eventCreator: manageTracking.errorApiServiceTracking(errorInfo, parseInt(response.code, 10), response.status, actionType.START),
  }));
}

export function errorApiGeeTracking(response, actionType, endpoint, dispatch) {
  const endpointNormalized = endpoint ? endpoint : '';
  const extraInfo = response?.extraInfo?.debugging_stuff_here ? `${response.extraInfo.debugging_stuff_here} ${endpointNormalized}` : 'Error endpoint ' + endpointNormalized;

  const errorInfo = {
    errorData: {
      actionable: actionableCodes.ABORT,
      msg: (response.msg) ? response.msg : 'API_SERVICE_UNAVAILABLE',
      extraInfo: {
        'debugging_stuff_here': response?.faultstring ? response.faultstring : extraInfo,
      },
    },
  };

  dispatch(sendAnalytics({
    eventCreator: manageTracking.errorApiServiceTracking(errorInfo, 503, response.status, actionType.START),
  }));
}

/*        ---------------    RETRIEVE_PNR    ---------------        */
/**
 * @param {String} storefront - Storefront code
 * @param {String} language - Language code
 * @param {String} pnr - Pnr code
 * @param {String} last_name - Last name customer
 */
export const getManagePnrStart = (params) => ({
  type: asyncActionTypes.RETRIEVE_PNR.START,
  payload: { 'loadingPNR': true, params: params },
});

export const getManagePnr = (response, ticketNumber) => ({
  type: asyncActionTypes.RETRIEVE_PNR.SUCCESS,
  payload: {
    'response': response,
    'pnrInfo': response._collection[0],
    'loadingPNR': false,
    'ticketNumber': ticketNumber,
    'warnings': response._warnings._collection[0],
  },
});

export const getManagePnrFail = (error) => ({
  type: asyncActionTypes.RETRIEVE_PNR.FAIL,
  payload: {
    'loadingPNR': false,
    'response': error,
    'warnings': error?._warnings?._collection[0] || null,
  },
});

export function retrievePnr(storefront, language, {
  pnr,
  lastName,
  frequentFlyerNumber,
  frequentFlyerProgram,
}) {
  return function action(dispatch) {
    const opts = {
      'storeCode': storefront,
      'language': language,
      'posCode': 'WEB',
    };
    const authHeader = pnr ?
      `PNR name="${lastName}",reservation="${pnr}"` :
      `PNR name="${lastName}",ffp="${frequentFlyerProgram}",ffp_number="${frequentFlyerNumber}"`;
    dispatch(getManagePnrStart({ pnr, lastName, frequentFlyerNumber, frequentFlyerProgram }));
    const request = getPnr(opts, authHeader, false);
    request.then(response => {
      if (response.faultcode && response.faultstring) {
        errorApiGeeTracking(response, asyncActionTypes.RETRIEVE_PNR, 'manage', dispatch);
        dispatch(getManagePnrFail(response));
      } else if (response?._meta?.class === 'Incident') {
        if (response.code >= 400 && response.code <= 599) {
          incidentApiGeeTracking(response, asyncActionTypes.RETRIEVE_PNR, 'manage', dispatch);
        } else {
          const typeError = response && response.code === '13111801' ? asyncActionTypes.GET_GRANT_ACCESS : asyncActionTypes.RETRIEVE_PNR;
          incidentTracking(response, typeError, dispatch);
        }
        dispatch(getManagePnrFail(response));
      } else {
        dispatch(getManagePnr(response, pnr));
      }
    }).catch(error => {
      dispatch(getManagePnrFail(error));
    });
  };
}

export const getIropsElegibilityStart = () => ({
  type: asyncActionTypes.RETRIEVE_IROPS_ELEGIBILITY.START,
});

export const getManageIropsEligibility = (response) => ({
  type: asyncActionTypes.RETRIEVE_IROPS_ELEGIBILITY.SUCCESS,
  payload: {
    'eligibility': response.isEligibility,
    'cartId': response.cartId,
  },
});

export const getIropsElegibilityFail = (error) => ({
  type: asyncActionTypes.RETRIEVE_IROPS_ELEGIBILITY.FAIL,
  payload: error,
});

export function retrieveIropEligibility(storefront, language, {
  pnr,
  lastName,
}) {
  return function action(dispatch) {
    const opts = {
      headers: {
        language,
        store: storefront,
      },
    };
    const authHeader = `PNR name="${lastName}",reservation="${pnr}"`;

    dispatch(getIropsElegibilityStart());

    const request = getIropEligibility(opts, authHeader);
    request.then(response => {
      if (response.hasOwnProperty('isEligibility')) {
        dispatch(getManageIropsEligibility(response));
      } else {
        dispatch(getIropsElegibilityFail(response));

        const errorInfo = {
          errorData: {
            actionable: actionableCodes.CONTINUE,
            msg: 'API_SERVICE_UNAVAILABLE',
            extraInfo: 'api/v4/irops/pnrlookup/iropEligibility',
            'url': '/myb/es-mx/administra-tu-viaje',
          },
        };

        dispatch(sendAnalytics({
          eventCreator: manageTracking.errorIropsElegibilityTracking(errorInfo, '14331313', 500, asyncActionTypes.RETRIEVE_IROPS_ELEGIBILITY.START),
        }));
      }
    }).catch(error => {
      dispatch(getIropsElegibilityFail(error));
    });
  };
}

/**
 *
 * @returns
 */
export const setPriorityListStart = () => ({
  type: asyncActionTypes.MANAGE_RETRIEVE_PRIORITY_LIST.START,
});

export const setPriorityListSuccess = (response) => ({
  type: asyncActionTypes.MANAGE_RETRIEVE_PRIORITY_LIST.SUCCESS,
  payload: {
    'response': response,
  },
});

export const setPriorityListFail = (error) => ({
  type: asyncActionTypes.MANAGE_RETRIEVE_PRIORITY_LIST.FAIL,
  payload: error,
});

export function retrievePriorityList(dataToSend) {
  return function action(dispatch) {
    dispatch(setPriorityListStart());
    const request = postPrioritylist(dataToSend);
    request.then(response => {
      if (response) {
        const actionable = 'CONTINUE';
        const actionType = 'MANAGE_RETRIEVE_PRIORITY_LIST';
        if (response?.fault?.faultstring) {
          response.actionable = 'CONTINUE';
          response.code = '13111301';
          incidentApiGeeTracking(response, actionType, '/prioritylist', dispatch);
          dispatch(setPriorityListFail(response));
        }
        if (response?._meta?.class === 'Incident') {
          if (response?.code >= 400 && response?.code <= 599) {
            response.actionable = actionable;
            incidentApiGeeTracking(response, actionType, '/prioritylist', dispatch);
          } else {
            const typeError = response?.code === '13111801' ? asyncActionTypes.GET_GRANT_ACCESS : actionType;
            response.actionable = actionable;
            incidentTracking(response, typeError, dispatch);
          }
          dispatch(setPriorityListFail(response));
        } else if (response?.messageType === 'ERROR_MESSAGE') {
          const errorInfo = {
            actionType: actionType,
            errorData: {
              code: `${response?.errorCode}|${response?.httpStatus}|${actionType}`,
              actionable: actionable,
              msg: response?.message,
              extraInfo: {
                'debugging_stuff_here': response?.details,
              },
            },
          };

          dispatch(sendAnalytics({
            eventCreator: errorTracking.errorTracking(errorInfo),
          }));
          dispatch(setPriorityListFail(response));
        } else {
          dispatch(setPriorityListSuccess(response));
        }
      }
    }).catch(error => {
      dispatch(setPriorityListFail(error));
    });
  };
}

/**
 *  EMD Voucher compensation (MIATECH)
 * @returns
 */
export const getEMDVOucherCompensationStart = () => ({
  type: asyncActionTypes.MANAGE_RETRIEVE_EMD_VOUCHER_COMPENSATION.START,
});

export const getEMDVOucherCompensationSuccess = (response) => ({
  type: asyncActionTypes.MANAGE_RETRIEVE_EMD_VOUCHER_COMPENSATION.SUCCESS,
  payload: {
    'response': response,
  },
});

export const getEMDVOucherCompensationFail = (error) => ({
  type: asyncActionTypes.MANAGE_RETRIEVE_EMD_VOUCHER_COMPENSATION.FAIL,
  payload: error,
});

export function retrieveEMDVoucherCompensation({ pnr, storefront, language }) {
  return function action(dispatch) {
    const opts = {
      'pnr': pnr,
      'storeCode': storefront,
      'language': language,
      'posCode': 'WEB',
    };
    dispatch(getEMDVOucherCompensationStart());
    const request = getEMDVoucherCompensation(opts);
    request.then(response => {
      if (response._meta.class === 'Incident') {
        if (response.code >= 400 && response.code <= 599) {
          incidentApiGeeTracking(response, asyncActionTypes.MANAGE_RETRIEVE_EMD_VOUCHER_COMPENSATION, 'manage', dispatch);
        } else {
          const errorInfo = {
            actionType: 'MANAGE_RETRIEVE_EMD_VOUCHER_COMPENSATION',
            errorData: {
              code: `${response.code}|${response.status}|MANAGE_RETRIEVE_EMD_VOUCHER_COMPENSATION`,
              actionable: 'CONTINUE',
              msg: response?.msg,
              extraInfo: {
                'debugging_stuff_here': response?.extraInfo?.debugging_stuff_here,
              },
            },
          };

          dispatch(sendAnalytics({
            eventCreator: errorTracking.errorTracking(errorInfo),
          }));
        }
        dispatch(getEMDVOucherCompensationFail(response));
      } else {
        dispatch(getEMDVOucherCompensationSuccess(response));
      }
    }).catch(error => {
      dispatch(getEMDVOucherCompensationFail(error));
    });
  };
}

/*        ---------------    RETRIEVE_ALL_DESTINATION_INFO    ---------------        */
/**
 * @param {String} language - Language code
 * @param {String} airportCode - e.g. JFK. The CMS uses the field 'cityCode' to filter results.
 */
export function retrieveAllDestinationInfo(language, listAirportCode) {
  return function action(dispatch) {
    listAirportCode.map(airportCode => {
      dispatch(retrieveAllDestinationInfoStart());
      const request = getDestinationInfo(language, airportCode);
      request.then(response => {
        if (response) {
          if (response.error) {
            dispatch(retrieveAllDestinationInfoFail(response.error));
            const statusCode = response.error.response && response.error.response.status ? response.error.response.status : 503;
            const urlErrorEndpoint = response.error.request && response.error.request.responseURL ? response.error.request.responseURL : null;
            dispatch(sendAnalytics({
              eventCreator: errorTrackingFromCMS.errorFromCMS({
                'type': 'Fatal',
                'statusCode': statusCode,
                'code': '13110920',
                'actionable': 'ABORT',
                'actionType': 'RETRIEVE_CMS_SINGLE_DESTINATION_INFO ',
                'errorMsg': response.error.message ? `${response.error.message} ${urlErrorEndpoint}` : `CMS_SERVICE_UNAVAILABLE ${urlErrorEndpoint}`,
                'errorExtraInfo': response.error.stack ? response.error.stack : 'Service Unavailable from CMS, please try again some minutes later',
              }),
            }));
          } else {
            const obj = { 'airportCode': airportCode, 'response': response };
            dispatch(getAllDestinationInfoCMS(obj));
          }
        } else {
          const obj = { 'airportCode': airportCode, 'response': null };
          dispatch(getNoneDestinationInfoCMS(obj));
        }
      }).catch(error => {
        const urlErrorEndpoint = error.request && error.request.responseURL ? error.request.responseURL : null;
        dispatch(retrieveAllDestinationInfoFail(error));
        dispatch(sendAnalytics({
          eventCreator: errorTrackingFromCMS.errorFromCMS({
            'type': 'Fatal',
            'statusCode': 503,
            'code': '13110920',
            'actionable': 'ABORT',
            'actionType': 'RETRIEVE_CMS_SINGLE_DESTINATION_INFO ',
            'errorMsg': error.message ? `${error.message} ${urlErrorEndpoint}` : `CMS_SERVICE_UNAVAILABLE ${urlErrorEndpoint}`,
            'errorExtraInfo': error.stack ? error.stack : 'Service Unavailable from CMS, please try again some minutes later',
          }),
        }));
      });
    });
  };
}

export const retrieveAllDestinationInfoStart = () => ({
  type: asyncActionTypes.RETRIEVE_ALL_DESTINATION_INFO.START,
  payload: { 'loadingAllDestinationInfo': true },
});

export const getAllDestinationInfoCMS = response => ({
  type: asyncActionTypes.RETRIEVE_ALL_DESTINATION_INFO.SUCCESS,
  payload: response,
});

export const getNoneDestinationInfoCMS = response => ({
  type: asyncActionTypes.RETRIEVE_NONE_DESTINATION_INFO.SUCCESS,
  payload: response,
});

export const retrieveAllDestinationInfoFail = (error) => ({
  type: asyncActionTypes.RETRIEVE_ALL_DESTINATION_INFO.FAIL,
  payload: { 'loadingAllDestinationInfo': false, 'response': error },
});

/*        ---------------    RETRIVE_ALL_ANCILLARIES_PNR    ---------------        */
/*
 * @param {String} storeCode - storefront.
 * @param {String} cartId - cartId anidado en la respuesta
 * @param {String} language - language
 */
export function retriveAllAncillariesPNR(storefront, cartId, language = 'es', isCorporate = false) {
  return function action(dispatch) {
    const opts = {
      'storeCode': storefront,
      'posCode': 'WEB',
      'cartId': cartId,
      'language': language,
      'isCorporateFlow': isCorporate,
    };
    dispatch(getAllAncillariesPNRStart());
    const request = getAncillaries(opts, dispatch);
    request.then(response => {
      if (response.faultcode && response.faultstring) {
        errorApiGeeTracking(response, asyncActionTypes.RETRIVE_ALL_ANCILLARIES_PNR, 'ancillaries', dispatch);
      }
      if (response._meta.class === 'Incident') {
        if (response.code >= 400 && response.code <= 599) {
          incidentApiGeeTracking(response, asyncActionTypes.RETRIVE_ALL_ANCILLARIES_PNR, 'ancillaries', dispatch);
        } else {
          const typeError = response && response.code === '13111801' ? asyncActionTypes.GET_GRANT_ACCESS : asyncActionTypes.RETRIVE_ALL_ANCILLARIES_PNR;
          incidentTracking(response, typeError, dispatch);
        }
      } else {
        dispatch(getAllAncillariesPNR(response));
      }
    }).catch(error => {
      dispatch(getAllAncillariesPNRFail(error));
    });
  };
}

export const getAllAncillariesPNRStart = () => ({
  type: asyncActionTypes.RETRIVE_ALL_ANCILLARIES_PNR.START,
  payload: { 'loadingAncillaryList': true },
});

export const getAllAncillariesPNR = response => ({
  type: asyncActionTypes.RETRIVE_ALL_ANCILLARIES_PNR.SUCCESS,
  payload: response,
});

export const getAllAncillariesPNRFail = (error) => ({
  type: asyncActionTypes.RETRIVE_ALL_ANCILLARIES_PNR.FAIL,
  payload: { 'loadingAncillaryList': false, 'response': error },
});

export function chubbMybPrice(country, cartID, stateCode, activateFunction) { // retrive chubb price
  return function action(dispatch) {
    const opts = {
      'storeCode': country,
      'posCode': 'WEB',
      'cartId': cartID,
      'stateCode': stateCode,
    };
    dispatch(getChubbPriceStart());
    const request = getPriceChubb(opts, dispatch);
    request.then(response => {
      if (response.faultcode && response.faultstring) {
        errorApiGeeTracking(response, asyncActionTypes.RETRIEVE_CHUBBPRICES, 'chubbprices', dispatch);
      }
      if (response.isChubbPrice !== true && !Array.isArray(response)) {
        if (response.code >= 400 && response.code <= 599) {
          incidentApiGeeTracking(response, asyncActionTypes.RETRIEVE_CHUBBPRICES, 'chubbprices', dispatch);
        } else {
          const typeError = response && response.code === '13111801' ? asyncActionTypes.GET_GRANT_ACCESS : asyncActionTypes.RETRIEVE_CHUBBPRICES;
          incidentTracking(response, typeError, dispatch);
        }
      } else {
        dispatch(getChubbPrice(response));
        activateFunction();
        if (response.length === 0) {
          const metric = {
            actionable: 'CONTINUE',
            code: '13334001',
            msg: 'Desconexión con los servicios de CHUBB USA al cotizar los productos de seguro',
          };

          incidentTracking(metric, asyncActionTypes.RETRIEVE_CHUBBPRICES, dispatch);
        }
      }
    }).catch(error => {
      activateFunction();
      dispatch(getChubbPriceFail(error));
    });
  };
}

export const getChubbPriceStart = () => ({
  type: asyncActionTypes.RETRIEVE_CHUBBPRICES.START,
});

export const getChubbPrice = response => ({
  type: asyncActionTypes.RETRIEVE_CHUBBPRICES.SUCCESS,
  setPriceChubb: response,
});

export const getChubbPriceFail = error => ({
  type: asyncActionTypes.RETRIEVE_CHUBBPRICES.FAIL,
  setPriceChubb: error,
});

/**
 * Get seatmaps from the API
 *
 * @param {String} storefront - Current storefront code
 * @param {String} cartId - Shopping cart ID
 */
export function retrieveSeatmap(storefront, cartId, preselect, flagUpsellOffers) {
  return function action(dispatch) {
    // se hardcodea false el upgrade y  flagUpsellOffers es la vandera que se debe recibir para habilitar los asientosde cp con api en upgrade
    const opts = {
      'storeCode': storefront,
      'posCode': 'WEB',
      'cartId': cartId,
      'upgrade': flagUpsellOffers,
    };
    const request = getSeatMap(opts);
    dispatch(getSeatMapApiStart());
    request.then(response => {
      if (response.faultcode && response.faultstring) {
        errorApiGeeTracking(response, asyncActionTypes.RETRIEVE_SEATMAPS, 'seatmaps', dispatch);
      }
      if (response._meta.class === 'Incident') {
        if (response.code >= 400 && response.code <= 599) {
          incidentApiGeeTracking(response, asyncActionTypes.RETRIEVE_SEATMAPS, 'seatmaps', dispatch);
        } else {
          const typeError = response && response.code === '13111801' ? asyncActionTypes.GET_GRANT_ACCESS : asyncActionTypes.RETRIEVE_SEATMAPS;
          incidentTracking(response, typeError, dispatch);
        }
      }
      if (preselect) {
        dispatch(getSeatsPreselect(cartId, storefront));
      }
      dispatch(getSeatMapApi(response));
    }).catch(error => {
      dispatch(getSeatMapApiFail(error));
    });
  };
}

export function updateMealsSelected(cartId, storefront, language, mealsSelected) {
  return function action(dispatch) {
    const opts = {
      'storeCode': storefront,
      'posCode': 'WEB',
      'cartId': cartId,
      'language': language,
    };
    const request = postMealsSelected(opts, mealsSelected);
    dispatch(postMealsSelectedApiStart());
    request.then(response => {
      if (response.faultcode && response.faultstring) {
        errorApiGeeTracking(response, asyncActionTypes.SUBMIT_MEALS_SELECTED, 'manageSelectMeal', dispatch);
        dispatch(postMealsSelectedApiFail(response));
      }
      if (response._meta.class === 'Incident') {
        if (response.code >= 400 && response.code <= 599) {
          incidentApiGeeTracking(response, asyncActionTypes.SUBMIT_MEALS_SELECTED, 'manageSelectMeal', dispatch);
        } else {
          const typeError = response && response.code === '13111801' ? asyncActionTypes.GET_GRANT_ACCESS : asyncActionTypes.SUBMIT_MEALS_SELECTED;
          incidentTracking(response, typeError, dispatch);
        }
        dispatch(postMealsSelectedApiFail(response));
      }
      dispatch(postMealsSelectedApi(response));
    }).catch(error => {
      dispatch(postMealsSelectedApiFail(error));
    });
  };
}

/**
 * Get seatmaps from the API
 *
 * @param {String} storefront - Current storefront code
 * @param {String} cartId - Shopping cart ID
 */

export function updateShoppingCart(storefront, cartId, language, pnrModel, isRedeemed = false, indexPassenger, token, sendMetrics, userProfile, journeySuccessValidations, isLogginIn) {
  return function action(dispatch) {
    const opts = {
      'storeCode': storefront,
      'posCode': 'WEB',
      'cartId': cartId,
      'language': language,
      'indexPassenger': indexPassenger,
    };
    // Session Validate
    // const cartSessionData = {
    //   pnr: pnrModel?.pnrCode,
    //   name: pnrModel?.cart?.travelerCollection?.[0]?.lastName,
    //   changeSession: false,
    // };

    // const sessionRequest = getSessionStatus(cartSessionData);
    // sessionRequest.then(response => {
    //   dispatch(getSessionData(response.data));
    // });

    const request = putShopingCart(opts, pnrModel, isRedeemed, token);
    if (isLogginIn) {
      dispatch(putFFAssociationtStart());
    }
    dispatch(putShopingCartApiStart(opts));
    request.then(response => {
      const warnings = response._warnings._collection;

      if (response.faultcode && response.faultstring) {
        errorApiGeeTracking(response, asyncActionTypes.RETRIEVE_SHOPPING_CART, 'manageShoppingCart', dispatch);
        dispatch(getManagePnrFail(response));
        if (isLogginIn) {
          dispatch(putFFAssociationFail(response));
        }
      }
      if (warnings.length > 0) {
        dispatch(dualBuyAndRedeemedBaggages(false));
        dispatch(sendAnalytics({
          eventCreator: manageTracking.webErrorTracking('Profile', warnings[0]),
        }));
      }
      if (response._warnings._collection == 'Incident') {
        if (response.code >= 400 && response.code <= 599) {
          incidentApiGeeTracking(response, asyncActionTypes.RETRIEVE_SHOPPING_CART, 'manageShoppingCart', dispatch);
        } else {
          const typeError = response && response.code === '13111801' ? asyncActionTypes.GET_GRANT_ACCESS : asyncActionTypes.RETRIEVE_SHOPPING_CART;
          incidentTracking(response, typeError, dispatch);
        }

        dispatch(dualBuyAndRedeemedBaggages(false));
        dispatch(putShopingCartApiFail(response));
        if (isLogginIn) {
          dispatch(putFFAssociationFail(response));
        }
      } else {
        if (sendMetrics) {
          sendMetrics();
        }
        dispatch(putShopingCartApi(response, isRedeemed, indexPassenger));
        if (isLogginIn) {
          dispatch(putFFAssociationSuccess(response));
        }
        const shoppingCartValues = response;
        if (shoppingCartValues?.travelerInfo?._collection.length > 0) {
          if (journeySuccessValidations?.thereIsASeatWithNoPrice) {
            dispatch(
              sendAnalytics({
                eventCreator: seatsTracking.journeySuccess(pnrModel, 'Ancillary', userProfile, shoppingCartValues?.travelerInfo?._collection, journeySuccessValidations?.isActiveFlowCorporate),
              }));
          }
        }
      }
    }).catch(error => {
      dispatch(putShopingCartApiFail(error));
      dispatch(dualBuyAndRedeemedBaggages(false));
      if (isLogginIn) {
        dispatch(putFFAssociationFail(error));
      }
    });
  };
}

export function addFrequentFlyerNumber(status) {
  return function action(dispatch) {
    dispatch(addFrequentFlyerNumberSet(status));
  };
}

const addFrequentFlyerNumberSet = (status) => ({
  type: ADD_FREQUENT_FLYER_NUMBER,
  payload: status,
});

/* ------- RETRIEVE PAYMENT ---------- */
/*
  @param {Object}
*/
export function submitPaymentManage({ storefront, language, purchaseOrder, dataPnrToLoad }) {
  const storeCode = storefront.split('-')[1];
  return function action(dispatch) {
    const opts = {
      storeCode,
      language,
      posCode: 'WEB',
    };
    const request = submitPayment(opts, purchaseOrder);
    dispatch(setWasOnHoldFlag(purchaseOrder.isOnHold, purchaseOrder.shoppingCartModel));
    dispatch(submitPaymentStart(purchaseOrder.shoppingCartModel));
    request.then(response => {
      if (response.faultcode && response.faultstring) {
        errorApiGeeTracking(response, asyncActionTypes.SUBMIT_PAYMENT, 'managePurchaseOrder', dispatch);
        dispatch(submitPaymentFail(response, purchaseOrder));
      }
      if (response._meta.class == 'Incident') {
        if (response.code === '13330701' || response.code === '13430701') {
          dispatch(submitPaymentFail(response, purchaseOrder));
        } else if (response.code === '13431301') {
          dispatch(submitPaymentFail(response, purchaseOrder));
          dispatch(handleDisconnectModal(true));
        } else if (response.code === '13111811' || response.code === '13110702' || response.code === '13110108') {
          dispatch(submitPaymentFail(response, purchaseOrder));
          dispatch(upgradeVoucherCreators('MODAL_DISCONNECTION_UPGRADE', true));
        } else {
          if (response.code >= 400 && response.code <= 599) {
            incidentApiGeeTracking(response, asyncActionTypes.SUBMIT_PAYMENT, 'managePurchaseOrder', dispatch);
          } else {
            const typeError = response && response.code === '13111801' ? asyncActionTypes.GET_GRANT_ACCESS : asyncActionTypes.SUBMIT_PAYMENT;
            incidentTracking(response, typeError, dispatch);
          }
          dispatch(submitPaymentFail(response, purchaseOrder));
        }
      } else {
        dispatch(submitPaymentApi(response));
        dispatch(reloadPnr(storefront, language, dataPnrToLoad));
        const responseContinue = response._warnings && response._warnings._collection && response._warnings._collection[0];
        if (responseContinue && responseContinue.code && responseContinue.code === '13330702') {
          const errorInfo = {
            errorData: {
              actionable: responseContinue.actionable,
              msg: responseContinue.msg,
              extraInfo: {
                'debugging_stuff_here': responseContinue?.extraInfo?.debugging_stuff_here || 'Error endpoint managePurchaseOrder',
              },
              url: Home(language, storeCode),
            },
          };

          dispatch(sendAnalytics({
            eventCreator: manageTracking.errorCPServiceTracking(errorInfo, responseContinue.code, 500, asyncActionTypes.SUBMIT_PAYMENT.START),
          }));
        }
      }
    }).catch(error => {
      dispatch(submitPaymentFail(error, purchaseOrder));
    });
  };
}

export function submitValidateEmdVoucherManage({ storefront, language, dataToSend }) {
  const storeCode = storefront.split('-')[1];
  return function action(dispatch) {
    dispatch(setEmdVoucherStart());
    const opts = {
      storeCode,
      language,
      posCode: 'WEB',
    };

    const request = submitValidateEmdVoucher(opts, dataToSend);
    request.then(response => {
      if (response.faultcode && response.faultstring) {
        errorApiGeeTracking(response, asyncActionTypes.SET_EMD_VOUCHER, 'manageValidateEmdVoucher', dispatch);
        dispatch(setEmdVoucherFail(response));
      }
      if (response._meta && response._meta.class == 'Incident') {
        if (response.code >= 400 && response.code <= 599) {
          incidentApiGeeTracking(response, asyncActionTypes.SET_EMD_VOUCHER, 'manageValidateEmdVoucher', dispatch);
        } else {
          const typeError = response && response.code === '13111801' ? asyncActionTypes.GET_GRANT_ACCESS : asyncActionTypes.SET_EMD_VOUCHER;
          incidentTracking(response, typeError, dispatch);
        }
        dispatch(setEmdVoucherFail(response));
      } else {
        const isValid = response.valid;
        const voucher = {};
        voucher.total = isValid ? response.balance.total : '';
        voucher.reason = !isValid ? response.errors[0] : '';
        dispatch(setEmdVoucher(response));
        dispatch(sendAnalytics({
          eventCreator: manageTracking.validateEMDVoucher(isValid, voucher),
        }));
      }
    }).catch(error => {
      dispatch(setEmdVoucherFail(error));
    });
  };
}

export function submitRemoveEmdVoucherManage({ storefront, language, cartId }) {
  const storeCode = storefront.split('-')[1];
  return function action(dispatch) {
    dispatch(removeEmdVoucherStart());
    const opts = {
      storeCode,
      language,
      posCode: 'WEB',
      cartId,
    };
    const request = submitRemoveEmdVoucher(opts);
    request.then(response => {
      if (response.faultcode && response.faultstring) {
        errorApiGeeTracking(response, asyncActionTypes.REMOVE_EMD_VOUCHER, 'manageRemoveEmdVoucher', dispatch);
        dispatch(removeEmdVoucherFail(response));
      }
      if (response._meta && response._meta.class == 'Incident') {
        if (response.code >= 400 && response.code <= 599) {
          incidentApiGeeTracking(response, asyncActionTypes.REMOVE_EMD_VOUCHER, 'manageRemoveEmdVoucher', dispatch);
        } else {
          const typeError = response && response.code === '13111801' ? asyncActionTypes.GET_GRANT_ACCESS : asyncActionTypes.REMOVE_EMD_VOUCHER;
          incidentTracking(response, typeError, dispatch);
        }
        dispatch(removeEmdVoucherFail(response));
      } else {
        dispatch(removeEmdVoucher(response));
      }
    }).catch(error => {
      dispatch(removeEmdVoucherFail(error));
    });
  };
}

export function submitRemoveEmdVoucherManageWithoutAPI() {
  return function action(dispatch) {
    dispatch(removeEmdVoucherWithoutAPI());
  };
}

export function resetInputVoucherValueManage() {
  return function action(dispatch) {
    dispatch(resetInputVoucherValueAPI());
  };
}

export function setValidVoucherVarsManage() {
  return function action(dispatch) {
    dispatch(setValidVoucherVarsAPI());
  };
}

const setWasOnHoldFlag = (status, cartOnHold) => ({
  type: WAS_ON_HOLD,
  payload: { status: status, cartOnHold: cartOnHold },
});

function reloadPnr(storefront, language, dataPnrToLoad) {
  const store = storefront.split('-');
  return function action(dispatch) {
    const opts = {
      'storeCode': store[1],
      'language': language,
      'posCode': 'WEB',
    };
    const authHeader = dataPnrToLoad.pnr ?
      `PNR name="${dataPnrToLoad.lastName}",reservation="${dataPnrToLoad.pnr}"` :
      `PNR name="${dataPnrToLoad.lastName}",ffp="${dataPnrToLoad.frequentFlyerProgram}",ffp_number="${dataPnrToLoad.frequentFlyerNumber}"`;
    const request = getPnr(opts, authHeader);

    request.then(response => {
      if (response.faultcode && response.faultstring) {
        errorApiGeeTracking(response, asyncActionTypes.RETRIEVE_PNR, 'manage', dispatch);
        dispatch(getManagePnrFail(response));
      } else if (response?._meta?.class === 'Incident') {
        if (response.code >= 400 && response.code <= 599) {
          incidentApiGeeTracking(response, asyncActionTypes.RETRIEVE_PNR, 'manage', dispatch);
        } else {
          const typeError = response && response.code === '13111801' ? asyncActionTypes.GET_GRANT_ACCESS : asyncActionTypes.RETRIEVE_PNR;
          incidentTracking(response, typeError, dispatch);
        }
        dispatch(getManagePnrFail(response));
      } else {
        dispatch(getManagePnr(response, dataPnrToLoad.pnr));
        dispatch(reloadAllAncillariesPNR(storefront, response._collection[0].cart._meta.cartId));
      }
    }).catch(error => {
      dispatch(getManagePnrFail(error));
    });
  };
}

function reloadAllAncillariesPNR(storefront, cartId) {
  const storeCode = storefront.split('-')[1];
  return function action(dispatch) {
    const opts = {
      'storeCode': storeCode,
      'posCode': 'WEB',
      'cartId': cartId,
    };
    const request = getAncillaries(opts, dispatch);
    request.then(response => {
      if (response.faultcode && response.faultstring) {
        errorApiGeeTracking(response, asyncActionTypes.RETRIVE_ALL_ANCILLARIES_PNR, 'ancillaries', dispatch);
      }
      if (response._meta.class === 'Incident') {
        incidentApiGeeTracking(response, asyncActionTypes.RETRIVE_ALL_ANCILLARIES_PNR, 'ancillaries', dispatch);
        dispatch(getAllAncillariesPNRFail(response));
      } else {
        dispatch(getAllAncillariesPNR(response));
        dispatch(setReloadBaggageFlag(true));
      }
    }).catch(error => {
      dispatch(getAllAncillariesPNRFail(error));
    });
  };
}

export const setReloadBaggageFlag = (status) => ({
  type: RELOAD_BAGGAGE_FLAG,
  payload: { status: status },
});

export const dualBuyAndRedeemedBaggages = (status) => ({
  type: asyncActionTypes.DUAL_BUY_REDEEMED_BAGGAGES,
  payload: { status: status },
});

const submitPaymentStart = (shoppingCart) => ({
  type: asyncActionTypes.SUBMIT_PAYMENT.START,
  payload: {
    amountTotal: shoppingCart.getAmountTotal(),
    amountTotalPoints: shoppingCart.getTotalPoints(),
    taxesTotal: shoppingCart.getTaxesTotal(),
    taxDetailList: shoppingCart.getTaxDetailsAsList(),
  },
});

const submitPaymentApi = response => ({
  type: asyncActionTypes.SUBMIT_PAYMENT.SUCCESS,
  payload: response,
});

const submitPaymentFail = (error, purchaseOrder) => ({
  type: asyncActionTypes.SUBMIT_PAYMENT.FAIL,
  payload: { 'response': error, 'purchaseOrder': purchaseOrder },
});
/* ------- END RETRIEVE PAYMENT ---------- */

export function setAllDestinationsRedux() {
  return function action(dispatch) {
    dispatch(setAllDestinations(true));
  };
}

export function getSeatsPreselect(cartId, storefront) {
  const storeCode = storefront.split('-')[1];
  return function action(dispatch) {
    const opts = {
      cartId,
      storeCode,
      posCode: 'WEB',
    };
    const request = getPreselectSeats(opts);
    dispatch(getSeatsPreselectStart());
    request.then(response => {
      if (response._meta.class == 'Incident') {
        dispatch(getSeatsPreselectFail(response));
      } else {
        dispatch(getSeatsPreselectSuccess(response));
      }
    }).catch(error => {
      dispatch(getSeatsPreselectFail(error));
    });
  };
}

export function putFFNumber(dataFFNumber, storefront, userToken) {
  const storeCode = storefront.split('-')[1];

  return function action(dispatch) {
    const opts = {
      storeCode,
      headers: {
        'client': 'ecommerce',
        'flow': 'myb',
        'posCode': 'WEB',
        'user-token': userToken,
        'Content-Type': 'application/json',
      },
    };

    dispatch(putFFAssociationtStart());
    const request = putFFNumberMicro(dataFFNumber, opts);
    request.then(response => {
      if (response.errorCode) {
        const errorCodes = ['13331307', '13111316', '13330309', '13330310', '13330311', '13330709', '13331308', '13531301', '13530304', '13530305', '13331309', '13330312', '13330313', '13330314', '13332801', '13531302'];

        if (errorCodes.includes(response.errorCode)) {
          const errorInfo = {
            actionType: 'FFN_ASSOCIATION',
            errorData: {
              code: `${response.errorCode}|${response.httpStatus}|FFN_ASSOCIATION`,
              actionable: response.event,
              msg: response.message,
              extraInfo: {
                'debugging_stuff_here': response.messageType,
              },
            },
          };

          const webErrorInfo = {
            actionable: response.event,
            code: response.errorCode,
            extraInfo: {
              'debugging_stuff_here': response.details,
            },
            status: response.status,
            msg: response?.message || response?.msg,
          };

          dispatch(sendAnalytics({
            eventCreator: manageTracking.webErrorTracking('Profile', webErrorInfo),
          }));

          dispatch(sendAnalytics({
            eventCreator: errorTracking.errorTracking(errorInfo),
          }));
        }

        dispatch(putFFAssociationFail(response));
      } else if (response._meta && response._meta.class && response._meta.class == 'Incident') {
        if (response.code >= 400 && response.code <= 599) {
          incidentApiGeeTracking(response, 'FFN_ASSOCIATION', 'FFN_ASSOCIATION', dispatch);
        }
      } else {
        const dataResponse = get(response, 'data.response', {});

        dispatch(putFFAssociationSuccess(dataResponse));
      }
    }).catch(error => {
      dispatch(putFFAssociationFail(error));
    });
  };
}

export const addStateStoreFronts = storeFront => ({
  type: asyncActionTypes.SET_STATE_STORE_FRONT.SUCCESS,
  payload: storeFront,
});

export const setStateStoreFront = response => ({
  type: asyncActionTypes.SET_STORE_FRONT.SUCCESS,
  payload: response,
});

export const setStateLanguage = response => ({
  type: asyncActionTypes.SET_LANGUAGE.SUCCESS,
  payload: response,
});

export const getSeatMapApiStart = () => ({
  type: asyncActionTypes.RETRIEVE_SEATMAPS.START,
});

export const getSeatMapApi = seatmap => ({
  type: asyncActionTypes.RETRIEVE_SEATMAPS.SUCCESS,
  payload: seatmap,
});

export const getSeatMapApiFail = error => ({
  type: asyncActionTypes.RETRIEVE_SEATMAPS.FAIL,
  payload: error,
});

export const getMealsMenuApiStart = () => ({
  type: asyncActionTypes.RETRIEVE_MEALSMENU.START,
});

export const getMealsMenuApi = mealsmenu => ({
  type: asyncActionTypes.RETRIEVE_MEALSMENU.SUCCESS,
  payload: mealsmenu,
});

export const getMealsMenuApiFail = error => ({
  type: asyncActionTypes.RETRIEVE_MEALSMENU.FAIL,
  payload: error,
});

export const postMealsSelectedApiStart = () => ({
  type: asyncActionTypes.SUBMIT_MEALS_SELECTED.START,
});

export const postMealsSelectedApi = mealsSelected => ({
  type: asyncActionTypes.SUBMIT_MEALS_SELECTED.SUCCESS,
  payload: mealsSelected,
});

export const postMealsSelectedApiFail = error => ({
  type: asyncActionTypes.SUBMIT_MEALS_SELECTED.FAIL,
  payload: error,
});

export const putShopingCartApiStart = (data) => ({
  data,
  type: asyncActionTypes.RETRIEVE_SHOPPING_CART.START,
});

export const putShopingCartApi = (response, isRedeemed, indexPassenger) => ({
  type: asyncActionTypes.RETRIEVE_SHOPPING_CART.SUCCESS,
  payload: { 'response': response, 'isRedeemed': isRedeemed, 'indexPassengerBack': indexPassenger },
});

export const putShopingCartApiFail = error => ({
  type: asyncActionTypes.RETRIEVE_SHOPPING_CART.FAIL,
  payload: error,
});

export const setAllDestinations = response => ({
  type: asyncActionTypes.SET_DESTINATIONS.SUCCESS,
  payload: response,
});

export const getFormsOfPaymentCollectionStart = () => ({
  type: asyncActionTypes.FORM_OF_PAYMENTS.START,
});

export const getFormsOfPaymentCollection = response => ({
  type: asyncActionTypes.FORM_OF_PAYMENTS.SUCCESS,
  payload: response,
});

export const getFormsOfPaymentCollectionFail = error => ({
  type: asyncActionTypes.FORM_OF_PAYMENTS.FAIL,
  payload: error,
});

export function getPaymentMethods(store, cartID, isCorporate = false) {
  return function action(dispatch) {
    const opts = {
      'cartId': cartID,
      'isCorporateFlow': isCorporate,
      'posCode': 'WEB',
      'storeCode': store,
    };
    const request = getFormsOfPayment(opts);
    dispatch(getFormsOfPaymentCollectionStart());
    request.then(response => {
      if (response.faultcode && response.faultstring) {
        errorApiGeeTracking(response, asyncActionTypes.FORM_OF_PAYMENTS, 'manageFormsOfPayment', dispatch);
        dispatch(getFormsOfPaymentCollectionFail(response));
      }
      if (response._meta && response._meta.class == 'Incident') {
        if (response.code >= 400 && response.code <= 599) {
          incidentApiGeeTracking(response, asyncActionTypes.FORM_OF_PAYMENTS, 'manageFormsOfPayment', dispatch);
        } else {
          const typeError = response && response.code === '13111801' ? asyncActionTypes.GET_GRANT_ACCESS : asyncActionTypes.FORM_OF_PAYMENTS;
          incidentTracking(response, typeError, dispatch);
        }
        dispatch(getFormsOfPaymentCollectionFail(response));
      } else {
        dispatch(getFormsOfPaymentCollection(response));
      }
    });
  };
}

/* ------- Send email ---------- */
/*
  @param {Object}
*/
export function sendEmailItinerary({ storefront, language, email, lastName, reservation, cartId }) {
  return function action(dispatch) {
    const request = sendEmailItineraryPnrRequest(storefront, language, email, lastName, reservation, cartId);
    dispatch(sendEmailItineraryStart());
    request.then(response => {
      if (response.faultcode && response.faultstring) {
        errorApiGeeTracking(response, asyncActionTypes.SEND_EMAIL_ITINERARY_REQUEST, 'manageEmailReceipt', dispatch);
        dispatch(sendEmailItineraryFail(response));
      }
      if (response._meta && response._meta.class == 'Incident') {
        if (response.code >= 400 && response.code <= 599) {
          incidentApiGeeTracking(response, asyncActionTypes.SEND_EMAIL_ITINERARY_REQUEST, 'manageEmailReceipt', dispatch);
        } else {
          const typeError = response && response.code === '13111801' ? asyncActionTypes.GET_GRANT_ACCESS : asyncActionTypes.SEND_EMAIL_ITINERARY_REQUEST;
          incidentTracking(response, typeError, dispatch);
        }
        dispatch(sendEmailItineraryFail(response));
      } else {
        dispatch(sendEmailItinerarySuccess(response));
      }
    }).catch(error => {
      dispatch(sendEmailItineraryFail(error));
    });
  };
}

export function setSendEmailItineraryRedux() {
  return function action(dispatch) {
    dispatch(setSendEmailItinerary(true));
  };
}

export function getControlPanel() {
  return function action(dispatch) {
    const request = getControlPanelCMS();
    dispatch(getControlPanelStart());
    request.then(response => {
      if (response.error) {
        const statusCode = response?.error?.response?.status || 503;
        const urlErrorEndpoint = response?.error?.request?.responseURL || null;
        const actionable = statusCode === 403 ? 'CONTINUE' : 'ABORT';
        dispatch(getControlPanelFail(response.error));
        dispatch(sendAnalytics({
          eventCreator: errorTrackingFromCMS.errorFromCMS({
            'event': 'error',
            'type': 'FATAL',
            'statusCode': statusCode,
            'code': '13110917',
            'actionable': actionable,
            'actionType': 'RETRIEVE_CMS_CONTROL_PANEL',
            'errorMsg': response.error.message ? `${response.error.message} ${urlErrorEndpoint}` : `CMS_SERVICE_UNAVAILABLE ${urlErrorEndpoint}`,
            'errorExtraInfo': response?.error?.stack || 'Service Unavailable from CMS, please try again some minutes later',
          }),
        }));
      } else {
        dispatch(getControlPanelSuccess(response));
      }
    }).catch(error => {
      const urlErrorEndpoint = error?.request?.responseURL || null;
      dispatch(getControlPanelFail(error));
      dispatch(sendAnalytics({
        eventCreator: errorTrackingFromCMS.errorFromCMS({
          'event': 'error',
          'type': 'FATAL',
          'statusCode': 503,
          'code': '13110917',
          'actionable': 'ABORT',
          'actionType': 'RETRIEVE_CMS_CONTROL_PANEL',
          'errorMsg': error.message ? `${error.message} ${urlErrorEndpoint}` : `CMS_SERVICE_UNAVAILABLE ${urlErrorEndpoint}`,
          'errorExtraInfo': error?.stack || 'Service Unavailable from CMS, please try again some minutes later',
        }),
      }));
    });
  };
}

export const getControlPanelStart = () => ({
  type: asyncActionTypes.CONTROL_PANEL.START,
  payload: { 'loadingControlPanel': true, success: false },
});

export const getControlPanelSuccess = response => ({
  type: asyncActionTypes.CONTROL_PANEL.SUCCESS,
  payload: { 'loadingControlPanel': false, ...response, success: true },
});

export const getControlPanelFail = error => ({
  type: asyncActionTypes.CONTROL_PANEL.FAIL,
  payload: { 'loadingControlPanel': false, ...error, success: true },
});

export function getErrorMessage(errorCode, language, shouldDelete = false) {
  return function action(dispatch) {
    if (typeof errorCode === 'string' && !errorCode?.includes('ERR.')) {
      const request = getErrorMessageCMS(errorCode, language);
      dispatch(getErrorMessageStart());

      request.then(response => {
        dispatch(getErrorMessageSuccess(response));
      }).catch(error => {
        dispatch(getErrorMessageFail(error));
      }).finally(() => {
        if (shouldDelete) {
          dispatch(getErrorMessageDelete());
        }
      });
    }
  };
}

export const getErrorMessageStart = () => ({
  type: asyncActionTypes.GET_ERROR_MESSAGE.START,
});

export const getErrorMessageSuccess = response => ({
  type: asyncActionTypes.GET_ERROR_MESSAGE.SUCCESS,
  payload: response,
});

export const getErrorMessageFail = error => ({
  type: asyncActionTypes.GET_ERROR_MESSAGE.FAIL,
  payload: error,
});

export const getErrorMessageDelete = () => ({
  type: asyncActionTypes.GET_ERROR_MESSAGE.DELETE,
});

export const sendEmailItineraryStart = () => ({
  type: asyncActionTypes.SEND_EMAIL_ITINERARY_REQUEST.START,
});

export const sendEmailItinerarySuccess = response => ({
  type: asyncActionTypes.SEND_EMAIL_ITINERARY_REQUEST.SUCCESS,
  payload: response,
});

export const sendEmailItineraryFail = error => ({
  type: asyncActionTypes.SEND_EMAIL_ITINERARY_REQUEST.FAIL,
  payload: error,
});

export const setSendEmailItinerary = response => ({
  type: asyncActionTypes.SET_EMAIL_ITINERARY,
  payload: response,
});

export const userProfile = credentials => ({
  type: asyncActionTypes.USER_LOGIN,
  payload: credentials,
});

export const userProfileRecoveryPassword = clubPremierNumber => ({
  type: asyncActionTypes.SET_EMAIL_ITINERARY,
  payload: clubPremierNumber,
});
export const removeAncillaryFromTravelers = (travelers, ancillaryType) => ({
  type: REMOVE_ANCILLARY_FROM_TRAVELERS,
  payload: { 'travelers': travelers, 'ancillaryType': ancillaryType },
});

export const removeAncillaryPIFromTravelers = (travelers, ancillaryType) => ({
  type: REMOVE_ANCILLARY_PI_FROM_TRAVELERS,
  payload: { 'travelers': travelers, 'ancillaryType': ancillaryType },
});

export const deepLinkAncillary = ancillaryType => ({
  type: DEEP_LINK_ANCILLARY,
  payload: { 'ancillaryType': ancillaryType },
});

export const deepLinkSeats = () => ({
  type: DEEP_LINK_SEATS,
});

export const getInitialConfirmationModel = (initialState) => ({
  type: INITIAL_CONFIRMATION_MODEL,
  payload: { 'confirmationModel': initialState },
});

export const updateStateFareLock = (initialState) => ({
  type: UPDATE_STATE_FARE_LOCK,
  payload: { 'stateFareLock': initialState },
});

/*        ---------------  Schedule Changue - change itinerary  ---------------        */
/**
 * @param {String} pnrValue - Number of pnr.
 * @param {String} lastNameValue - Last name of passenger prinmary.
 */

export function changeItineraryAction(pnrValue, lastNameValue, post, store, cartID, listFlightInfo = [], pageRedirect, country, language) {
  return function action(dispatch) {
    dispatch(changeItineraryStart());

    const opts = changeItineraryClassOpts(pnrValue, lastNameValue, post, store, cartID, listFlightInfo);
    const request = changeItinerary(opts); // API

    request.then(response => {
      if (response && response.message) {
        response = response.message;
      }

      if (response === 'SUCCESS') {
        dispatch(changeItineraryStartSuccess(response));
        if (pageRedirect) {
          const commonUrl = getCMSUrl(country, language, 'MANAGE_YOUR_BOOKING');
          let trips = 'trips';
          trips = language === 'pt' ? 'viagens' : 'trips';
          const redirectUrl = `${commonUrl}/${trips}?last-name=${lastNameValue}&pnr=${pnrValue}`;
          window.location.replace(redirectUrl);
        }
      } else {
        dispatch(changeItineraryStartFail(response)); /* Error de sabre al realizar cambio de itinerario */
      }
    }).catch(error => {
      dispatch(changeItineraryStartFail(error));
    });
  };
}

export const changeItineraryStart = () => ({
  type: asyncActionTypes.CHANGE_ITINERARY.START,
  payload: { 'loadingPChangeItineraryRequestStart': true },
});

export const changeItineraryStartSuccess = (response) => {
  const message = response;
  return {
    type: asyncActionTypes.CHANGE_ITINERARY.SUCCESS,
    payload: response,
    message,
  };
};

export const changeItineraryStartFail = (error) => {
  return {
    type: asyncActionTypes.CHANGE_ITINERARY.FAIL,
    payload: error,
  };
};
/*        ---------------  Schedule Changue - change itinerary  ---------------        */

export function userSignUpAction(data, store) {
  return function action(dispatch) {
    dispatch(userGetOtpStart());
    dispatch(userSignUpStart());
    const request = userProfileSignUp(data);
    request.then(response => {
      if (response?.code) {
        const errorCode = response.code;
        if (ENROLLMENT_ABORT_ERRORS.includes(errorCode)) {
          dispatch(userSendOtpFail(response, true, store));
          return;
        }
        dispatch(userSignUpFail(response, false, store));
        dispatch(userGetOtpFail(response));
      } else {
        dispatch(userSignUpSuccess(response, store));
        userGetOtpSuccess();
      }
    }).catch(error => {
      dispatch(userSignUpFail(error, false, store));
    });
  };
}

export const userSignUpStart = () => ({
  type: asyncActionTypes.USER_ENROLLMENT.START,
  payload: { 'loadingProfileRequestStart': true },
});

export const userSignUpSuccess = (response, store) => {
  return {
    type: asyncActionTypes.USER_ENROLLMENT.SUCCESS,
    payload: response,
    store,
  };
};

export const userSignUpFail = (response, otpServiceError = false, store) => {
  return {
    type: asyncActionTypes.USER_ENROLLMENT.FAIL,
    otpServiceError: otpServiceError,
    payload: response,
    store,
  };
};

export const userGetOtpFail = (response, otpServiceError = false) => {
  return {
    type: asyncActionTypes.GET_OTP.FAIL,
    otpServiceError: otpServiceError,
    payload: response,
  };
};

export const userGetOtpStart = () => {
  return {
    type: asyncActionTypes.GET_OTP.START,
  };
};

export const userGetOtpSuccess = () => {
  return {
    type: asyncActionTypes.GET_OTP.SUCCESS,
  };
};

export function userSignUpSendOtp(data, pos, store) {
  return function action(dispatch) {
    dispatch(userSendOtpStart());

    const request = userProfileSendOtp(data);

    request.then(response => {
      if (response?.code) {
        const errorCode = response.code;
        if (ENROLLMENT_ABORT_ERRORS.includes(errorCode)) {
          dispatch(userSendOtpFail(response, true, store));
          return;
        }

        dispatch(userSendOtpFail(response, false, store));
      } else {
        dispatch(userSendOtpSuccess(store));
      }
    }).catch(error => {
      return error;
    });
  };
}

export const userSendOtpFail = (response, otpServiceError = false, store) => {
  return {
    type: asyncActionTypes.SEND_OTP.FAIL,
    otpServiceError: otpServiceError,
    payload: response,
    store,
  };
};

export const userSendOtpStart = () => {
  return {
    type: asyncActionTypes.SEND_OTP.START,
  };
};

export const userSendOtpSuccess = (store) => {
  return {
    type: asyncActionTypes.SEND_OTP.SUCCESS,
    store,
  };
};

export function userSignUpGetOtp() {
  return function action(dispatch) {
    dispatch(userGetOtpSuccess());
  };
}

export function userProfileRegistrationEmailValidationAction(data, store) {
  return function action(dispatch) {
    const request = userProfileRegistrationEmailValidation(data);
    request.then(response => {
      // if errors
      dispatch(userProfileRegistrationValidateEmailStart());
      if (response?._meta?.class === 'Incident') {
        const errorCode = response.code;
        if (ENROLLMENT_ABORT_ERRORS.includes(errorCode)) {
          dispatch(userProfileRegistrationValidateEmailFail(response, true, null, null, store));
          return;
        }
        switch (errorCode) {
          case 'ERR.UB.ENROLLMENT.DUPLICATE_EMAIL':
            dispatch(userProfileRegistrationValidateEmailFail(response, false, formFieldCopyIDs.userProfileDuplicateEmail, data, store));
            break;
          case 'ERR.UB.ENROLLMENT.INVALID_EMAIL':
            dispatch(userProfileRegistrationValidateEmailFail(response, false, formFieldCopyIDs.userProfileInvalidEmailFormat, data, store));
            break;
        }
      } else {
        dispatch(userProfileRegistrationValidateEmailSuccess(response, store));
      }
    }).catch(err => {
      return err;
    });
  };
}

export function userProfileRegistrationValidateEmailStart() {
  return {
    type: asyncActionTypes.VALIDATE_EMAIL.START,
  };
}

export function userProfileRegistrationValidateEmailFail(response, enrollmentServiceError, copyID = undefined, email = undefined, store) {
  return {
    type: asyncActionTypes.VALIDATE_EMAIL.FAIL,
    copyID: copyID,
    duplicateEmail: email,
    enrollmentServiceError: enrollmentServiceError,
    payload: response,
    store,
  };
}

export const userProfileRegistrationValidateEmailSuccess = (response = undefined, store) => {
  return {
    type: asyncActionTypes.VALIDATE_EMAIL.SUCCESS,
    payload: response,
    store,
  };
};

export const enrollmentServiceErrorSuccess = () => {
  return {
    type: asyncActionTypes.ENROLLMENT_ERROR,
  };
};


export function userProfileRegistrationTutorValidationAction(data, store) {
  return function action(dispatch) {
    const request = userProfileRegistrationTutorValidation(data);
    request.then(response => {
      if (response?._meta?.class === 'Incident') {
        const errorCode = response.code;

        if (ENROLLMENT_ABORT_ERRORS.includes(errorCode)) {
          dispatch(userProfileRegistrationValidateTutorFail(response, true, null, null, { store, guardianAccount: data.guardianAccount }));
          return;
        }

        if (response.code === 'ERR.UB.ENROLLMENT.INVALID_GUARDIAN_CARD') {
          dispatch(userProfileRegistrationValidateTutorFail(response, false, null, null, { store, guardianAccount: data.guardianAccount }));
          return;
        }

        if (response.code === 'ERR.UB.ENROLLMENT.INVALID_GUARDIAN_EMAIL') {
          dispatch(userProfileRegistrationValidateTutorFail(response, false, formFieldCopyIDs.userProfileEmailNoMatchGuardian, data.guardianAccount, { store, guardianAccount: data.guardianAccount }));
        }
      } else {
        dispatch(userProfileRegistrationValidateTutorSuccess(response, data.guardianAccount, store));
      }
    }).catch(err => {
      return err;
    });
  };
}

export const userProfileRegistrationValidateTutorStart = () => {
  return {
    type: asyncActionTypes.VALIDATE_TUTOR.START,
  };
};

export const userProfileRegistrationValidateTutorFail = (response, enrollmentServiceError, copyID = undefined, guardianAccount = undefined, data) => {
  return {
    type: asyncActionTypes.VALIDATE_TUTOR.FAIL,
    copyID: copyID,
    enrollmentServiceError: enrollmentServiceError,
    guardianAccount: guardianAccount,
    payload: response,
    data,
  };
};

export const userProfileRegistrationValidateTutorSuccess = (response = undefined, guardianAccount, store) => {
  return {
    type: asyncActionTypes.VALIDATE_TUTOR.SUCCESS,
    payload: response,
    status: false,
    guardianAccount,
    store,
  };
};

/*        ---------------    User's session signIn  ---------------        */
/**
 * @param {String} clubPremierNumber - User's Club Premier Number.
 * @param {String} password - Use's Password account.
 */

export function userSignInAction(clubPremierNumber, email, password, sessionID, enteredOtp, ipAddress) {
  return function action(dispatch) {
    dispatch(userSignInStart());

    const opts = userSignInClassOpts(clubPremierNumber, email, password, sessionID, enteredOtp, ipAddress);
    const request = userProfileSignIn(opts); // API

    request.then(response => {
      if (response && response.code) {
        response = response.code;
      }

      switch (response) {
        case '100412':
          dispatch(userSignInStartFail(response));
          break;
        case '15330708':
          dispatch(userSignInStartFail(response));
          break;
        case '15420703':
          dispatch(userSignInStartFail(response));
          break;
        case '15111801':
          dispatch(userSignInStartFail(response));
          break;
        case '15111803':
          dispatch(userSignInStartFail(response));
          break;
        case '15111802':
          dispatch(userSignInStartFail(response));
          break;
        case '15530701':
          dispatch(userSignInStartInactive(response));
          break;
        case '500008': // Del lado de API se hara el cambio de este código por siguiente: 506001. Dejando el anterior para evitar que deje de funcionar alguna dependencia.
          dispatch(userSignInStartFail(response));
          break;
        case '500601': // Código anterior: 500008
          dispatch(userSignInStartFail(response));
          break;
        case '15530702': // Código anterior: 500601
          dispatch(userSignInStartFail(response));
          break;
        case '500211':
          dispatch(userSignInStartInactive(response));
          break;
        case '500208':
          dispatch(userSignInStartFail(response));
          break;
        case '500The profile could not be saved to DB.': // caso en el que se responde de api no hay bd
          dispatch(userSignInStartFail(response));
          break;
        case '15110101': // BASE DE DATOS nuevo codigo de respuesta para api cuando indica que no hay base de datos, codigo actualizado del caso anterior
          dispatch(userSignInStartFail(response));
          break;
        case '15110701': // CLUCB PREMIER nuevo codigo de respuesta para api cuando indica que no hay cp, cuando es el banner
          dispatch(userSignInStartFail(response));
          break;
        case '500016':
          dispatch(userSignInStartFail(response));
          break;
        case '17531301':
          dispatch(userSignInStartFail(response));
          break;
        case '17531302':
          dispatch(userSignInStartFail(response));
          break;
        case '17531303':
          dispatch(userSignInStartFail(response));
          break;
        case '17531304':
          dispatch(userSignInStartFail(response));
          break;
        default:
          dispatch(userSignInStartSuccess(response));
          dispatch(userSetDataCorporate(response));
          dispatch(ACTION_LOGIN(true));
          break;
      }
    }).catch(error => {
      dispatch(userSignInStartFail(error));
    });
  };
}

export const userSignInStart = () => ({
  type: asyncActionTypes.USER_SIGNIN.START,
  payload: { 'loadingPorfileRequestStart': true },
});

export const userSignInStartSuccess = (response) => {
  if (!response.metrixEmail) {
    formatUserSessionCookie(response);
    const userFirstName = getUserFirstName(response.userProfile.passengerData.firstName);
    const userFirstInitial = getInitials(response.userProfile.passengerData.firstName);
    const userSecondInitial = getInitials(response.userProfile.passengerData.lastName);
    const userInitials = `${userFirstInitial}${userSecondInitial}`;
    localStorage.setItem('firstName', userFirstName);
    localStorage.setItem('initials', userInitials);
    return {
      type: asyncActionTypes.USER_SIGNIN.SUCCESS,
      payload: response,
      userFirstName,
      userInitials,
    };
  } else {
    return {
      type: asyncActionTypes.USER_SIGNIN.SUCCESS,
      payload: response,
    };
  }
};

export const userSignInStartFail = (error) => {
  return {
    type: asyncActionTypes.USER_SIGNIN.FAIL,
    payload: error,
  };
};

export const userSignInStartInactive = (error) => {
  return {
    type: asyncActionTypes.USER_SIGNIN.FAIL,
    payload: error,
  };
};

export const removeCodeError = (error) => {
  return {
    type: asyncActionTypes.REMOVE_CODE_ERROR,
    payload: error,
  };
};

export const removeStatusCodeError = () => {
  return {
    type: asyncActionTypes.REMOVE_STATUS_CODE_ERROR,
  };
};
/*        ---------------    User's session validator actions   ---------------        */
/**
 * @param {String} token - User session token.
 */

export function checkSessionAction(token, pos) {
  return function action(dispatch) {
    dispatch(validateSessionStart());
    const request = userProfileIsValidCPSession(token, pos); // API
    request.then(response => {
      if (response?.status) {
        dispatch(validateSessionFail(response));
        dispatch(sendAnalytics({
          eventCreator: manageTracking.webErrorTracking('Profile', response),
        }));
      } else {
        dispatch(validateSessionSuccess(response, token));
      }
    }).catch(error => {
      dispatch(validateSessionFail(error));
    });
  };
}

export const validateSessionStart = () => ({
  type: asyncActionTypes.SESSION_CHECKER.START,
  payload: { 'checkSessionStart': true },
});

export const validateSessionSuccess = (response, token) => {
  const action = {
    type: asyncActionTypes.SESSION_CHECKER.SUCCESS,
    payload: response,
    token,
  };
  return action;
};

export const validateSessionFail = (error) => ({
  type: asyncActionTypes.SESSION_CHECKER.FAIL,
  payload: error,
});

/*        ---------------    User's camping validate actions   ---------------        */
/**
 * @param {Object} data - User session token.
 */

export function checkCampingEnrolledAction(data) {
  return retrieveUserCampingEnrolled(data).then((data) => data); // API
}

/*        ---------------    retrive user's profile actions   ---------------        */
/**
 * @param {String} token - User session token.
*/

export function retrieveProfileUserAction(token, pos) {
  return function action(dispatch) {
    dispatch(retrieveProfileUserStart());
    const request = retrieveProfileUserSession(token, pos); // API

    request.then(response => {
      if (response?.status || response?._meta?.class === 'Incident' || !response?.userProfile) {
        dispatch(retrieveProfileUserFail(response));

        dispatch(sendAnalytics({
          eventCreator: manageTracking.webErrorTracking('Profile', response),
        }));
      } else {
        dispatch(retrieveProfileUserSuccess(response, token));
      }
    }).catch(error => {
      dispatch(retrieveProfileUserFail(error));
    });
  };
}

export function retrieveCorporateProfileUserAction(token, pos) {
  return function action(dispatch) {
    dispatch(retrieveProfileUserStart());
    const helpers = {
      pos,
      token,
    };
    const request = retrieveProfileUserSession(helpers); // API
    request.then(response => {
      if (response.hasOwnProperty('status')) {
        dispatch(retrieveProfileUserFail(response));

        dispatch(sendAnalytics({
          eventCreator: manageTracking.webErrorTracking('Profile', response),
        }));
      } else {
        dispatch(retrieveProfileUserSuccess(response, token));
        dispatch(userSetDataCorporate(response, true));
      }
    }).catch(error => {
      dispatch(retrieveProfileUserFail(error));
    });
  };
}

export const retrieveProfileUserStart = () => ({
  type: asyncActionTypes.RETRIVE_USER_PROFILE.START,
  payload: { 'checkSessionStart': true },
});

export const retrieveProfileUserSuccess = (response, token) => {
  const userFirstName = getUserFirstName(response.userProfile.passengerData.firstName);
  const userFirstInitial = getInitials(response.userProfile.passengerData.firstName);
  const userSecondInitial = getInitials(response.userProfile.passengerData.lastName);
  const userInitials = `${userFirstInitial}${userSecondInitial}`;
  formatUserSessionCookie(response, token);
  localStorage.setItem('initials', userInitials);
  localStorage.setItem('firstName', userFirstName);

  const action = {
    type: asyncActionTypes.RETRIVE_USER_PROFILE.SUCCESS,
    payload: response,
    userFirstName,
    userInitials,
    token,
  };

  return action;
};

export const retrieveProfileUserFail = (error) => ({
  type: asyncActionTypes.RETRIVE_USER_PROFILE.FAIL,
  payload: error,
});

export const userSetDataCorporate = (response, retrieveProfile) => {
  const { corporateFlow } = response.userProfile;
  const objCorporate = corporateFlow && corporateFlow.data && Object.keys(corporateFlow.data).length;

  if (retrieveProfile) {
    return {
      type: asyncActionTypes.SET_DATA_CORPORATE_RETRIEVE_PROFILE.START,
      payload: corporateFlow,
    };
  }

  if (objCorporate > 0) {
    return {
      type: asyncActionTypes.SET_DATA_CORPORATE.START,
      payload: corporateFlow,
    };
  }
};

/*        ---------------  logout actions   ---------------        */
/*
 * @param {String} token - User session token.
*/

export function logoutSessionAction(token, pos) {
  return function action(dispatch) {
    dispatch(logoutSessionStart());
    const opts = userSignOutClassOpts(token, pos);
    const request = userProfileSignOut(opts, pos); // API

    request.then(response => {
      if (response.status) {
        dispatch(sendAnalytics({
          eventCreator: manageTracking.webErrorTracking('Profile', response),
        }));
      } else {
        dispatch(logoutSessionSuccess(response));
        safeLocalStorage.removeItem('savedBalance');
      }
    }).catch(error => {
      dispatch(logoutSessionFail(error));
    });
    safeLocalStorage.setItem('logoutFail', 1);
  };
}

export function logoutMicro(accountNumber, token) {
  return function action(dispatch) {
    dispatch(logoutMicroStart());
    const request = deleteSession({ accountNumber, token });

    request.then(response => {
      if (response.code) {
        dispatch(sendAnalytics({
          eventCreator: manageTracking.webErrorTracking('Profile', response),
        }));
        dispatch(logoutMicroFail({ response, accountNumber }));
      } else {
        dispatch(logoutMicroSuccess({ response, accountNumber }));
        safeLocalStorage.removeItem('savedBalance');
      }
    }).catch(error => {
      dispatch(logoutMicroFail(error));
    });
    safeLocalStorage.setItem('logoutFail', 1);
  };
}

export const getApiTimeStart = () => ({
  type: asyncActionTypes.PUT_TIME_API.START,
});

export const getApiTimeSuccess = response => ({
  type: asyncActionTypes.PUT_TIME_API.SUCCESS,
  payload: response,
});

export const getApiTimeFail = error => ({
  type: asyncActionTypes.PUT_TIME_API.FAIL,
  payload: error,
});

export const logoutMicroStart = () => ({
  type: asyncActionTypes.USER_PROFILE_LOGOUT.START,
  payload: { 'loadingPorfileRequestStart': true },
});

export const logoutMicroSuccess = (response) => ({
  type: asyncActionTypes.USER_PROFILE_LOGOUT.SUCCESS,
  payload: response,
});

export const logoutMicroFail = (error) => ({
  type: asyncActionTypes.USER_PROFILE_LOGOUT.FAIL,
  payload: error,
});

export const logoutSessionStart = () => ({
  type: asyncActionTypes.USER_LOGOUT.START,
  payload: { 'loadingPorfileRequestStart': true },
});

export const logoutSessionSuccess = (response) => ({
  type: asyncActionTypes.USER_LOGOUT.SUCCESS,
  payload: response,
});

export const logoutSessionFail = (error) => ({
  type: asyncActionTypes.USER_LOGOUT.FAIL,
  payload: error,
});

export const setEmdVoucherStart = () => ({
  type: asyncActionTypes.SET_EMD_VOUCHER.START,
});

export const setEmdVoucherFail = (response) => ({
  type: asyncActionTypes.SET_EMD_VOUCHER.FAIL,
  payload: { 'response': response },
});

export const setEmdVoucher = (response) => ({
  type: asyncActionTypes.SET_EMD_VOUCHER,
  payload: { 'response': response },
});

export const removeEmdVoucherStart = () => ({
  type: asyncActionTypes.REMOVE_EMD_VOUCHER.START,
});

export const removeEmdVoucherFail = (response) => ({
  type: asyncActionTypes.REMOVE_EMD_VOUCHER.FAIL,
  payload: { 'response': response },
});

export const removeEmdVoucher = (response) => ({
  type: asyncActionTypes.REMOVE_EMD_VOUCHER,
  payload: { 'response': response },
});

export const removeEmdVoucherWithoutAPI = () => ({
  type: asyncActionTypes.REMOVE_EMD_VOUCHER_WITHOUT_API,
});

export const resetInputVoucherValueAPI = () => ({
  type: asyncActionTypes.REMOVE_EMD_VOUCHER_VALUE,
});

export const setValidVoucherVarsAPI = () => ({
  type: asyncActionTypes.SET_VALID_VOUCHER_VARS,
});

const getSeatsPreselectStart = () => ({
  type: asyncActionTypes.SEAT_PRESELECT.START,
});

const getSeatsPreselectSuccess = response => ({
  type: asyncActionTypes.SEAT_PRESELECT.SUCCESS,
  payload: response,
});

const getSeatsPreselectFail = error => (
  {
    type: asyncActionTypes.SEAT_PRESELECT.FAIL,
    payload: error,
  }
);

const putFFAssociationtStart = () => ({
  type: asyncActionTypes.FFN_ASSOCIATION.START,
});

const putFFAssociationSuccess = response => ({
  type: asyncActionTypes.FFN_ASSOCIATION.SUCCESS,
  payload: response,
});

const putFFAssociationFail = error => (
  {
    type: asyncActionTypes.FFN_ASSOCIATION.FAIL,
    payload: error,
  }
);

export function retrieveMenuPromotions(storefrontId) {
  return function action(dispatch) {
    const request = getMenuPromotionsCMS(storefrontId);
    dispatch(menuPromotionsStart());
    request.then(response => {
      if (response.error) {
        const statusCode = response.error.response && response.error.response.status ? response.error.response.status : 503;
        const urlErrorEndpoint = response.error.request && response.error.request.responseURL ? response.error.request.responseURL : null;
        dispatch(menuPromotionsFail(response.error));
        dispatch(sendAnalytics({
          eventCreator: errorTrackingFromCMS.errorFromCMS({
            'event': 'error',
            'type': 'WARNING',
            'statusCode': statusCode,
            'code': '17330904',
            'actionable': 'CONTINUE',
            'actionType': 'RETRIEVE_CMS_MENU_PROMOTIONS',
            'errorMsg': response.error.message ? `${response.error.message} ${urlErrorEndpoint}` : `CMS_SERVICE_UNAVAILABLE ${urlErrorEndpoint}`,
            'errorExtraInfo': response.error.config.url ? response.error.config.url : 'Service Unavailable from CMS, please try again some minutes later',
          }),
        }));
      } else {
        dispatch(addMenuPromotions(response));
      }
    }).catch(error => {
      const urlErrorEndpoint = error.request && error.request.responseURL ? error.request.responseURL : null;
      dispatch(menuPromotionsFail(error));
      dispatch(sendAnalytics({
        eventCreator: errorTrackingFromCMS.errorFromCMS({
          'event': 'error',
          'type': 'WARNING',
          'statusCode': 503,
          'code': '17330904',
          'actionable': 'CONTINUE',
          'actionType': 'RETRIEVE_CMS_MENU_PROMOTIONS',
          'errorMsg': error.message ? `${error.message} ${urlErrorEndpoint}` : `CMS_SERVICE_UNAVAILABLE ${urlErrorEndpoint}`,
          'errorExtraInfo': error.config.url ? error.config.url : 'Service Unavailable from CMS, please try again some minutes later',
        }),
      }));
    });
  };
}

export const menuPromotionsStart = () => ({
  type: asyncActionTypes.RETRIEVE_CMS_MENU_PROMOTIONS.START,
});

export const addMenuPromotions = menuPromotions => ({
  type: asyncActionTypes.RETRIEVE_CMS_MENU_PROMOTIONS.SUCCESS,
  payload: menuPromotions,
});

export const menuPromotionsFail = (error) => ({
  type: asyncActionTypes.RETRIEVE_CMS_MENU_PROMOTIONS.FAIL,
  payload: error,
});

export function retrieveTravelInformation(storefrontId) {
  return function action(dispatch) {
    const request = getTravelInformationCMS(storefrontId);
    dispatch(travelInformationStart());
    request.then(response => {
      if (response.error) {
        const statusCode = response.error.response && response.error.response.status ? response.error.response.status : 503;
        const urlErrorEndpoint = response.error.request && response.error.request.responseURL ? response.error.request.responseURL : null;
        dispatch(menuPromotionsFail(response.error));
        dispatch(sendAnalytics({
          eventCreator: errorTrackingFromCMS.errorFromCMS({
            'event': 'error',
            'type': 'WARNING',
            'statusCode': statusCode,
            'code': '17330905',
            'actionable': 'CONTINUE',
            'actionType': 'RETRIEVE_CMS_MENU_TRAVEL_INFORMATION',
            'errorMsg': response.error.message ? `${response.error.message} ${urlErrorEndpoint}` : `CMS_SERVICE_UNAVAILABLE ${urlErrorEndpoint}`,
            'errorExtraInfo': response.error.config.url ? response.error.config.url : 'Service Unavailable from CMS, please try again some minutes later',
          }),
        }));
      } else {
        dispatch(addTravelInformation(response));
      }
    }).catch(error => {
      const urlErrorEndpoint = error.request && error.request.responseURL ? error.request.responseURL : null;
      dispatch(travelInformationFail(error));
      dispatch(sendAnalytics({
        eventCreator: errorTrackingFromCMS.errorFromCMS({
          'event': 'error',
          'type': 'WARNING',
          'statusCode': 503,
          'code': '17330905',
          'actionable': 'CONTINUE',
          'actionType': 'RETRIEVE_CMS_MENU_TRAVEL_INFORMATION',
          'errorMsg': error.message ? `${error.message} ${urlErrorEndpoint}` : `CMS_SERVICE_UNAVAILABLE ${urlErrorEndpoint}`,
          'errorExtraInfo': error.config.url ? error.config.url : 'Service Unavailable from CMS, please try again some minutes later',
        }),
      }));
    });
  };
}

export const travelInformationStart = () => ({
  type: asyncActionTypes.RETRIEVE_CMS_TRAVEL_INFORMATION.START,
});

export const addTravelInformation = travelInformation => ({
  type: asyncActionTypes.RETRIEVE_CMS_TRAVEL_INFORMATION.SUCCESS,
  payload: travelInformation,
});

export const travelInformationFail = (error) => ({
  type: asyncActionTypes.RETRIEVE_CMS_TRAVEL_INFORMATION.FAIL,
  payload: error,
});

export function retrieveAirportLiteNames(language) {
  return function action(dispatch) {
    const request = getAirportsLite(language);

    dispatch(AirportsLiteStart());

    request.then(response => {
      if (response.error) {
        const statusCode = response.error.response && response.error.response.status ? response.error.response.status : 503;
        const urlErrorEndpoint = response.error.request && response.error.request.responseURL ? response.error.request.responseURL : null;

        dispatch(AirportsLiteFail(response.error));

        dispatch(sendAnalytics({
          eventCreator: errorTrackingFromCMS.errorFromCMS({
            'event': 'error',
            'type': 'ABORT',
            'statusCode': statusCode,
            'code': '12111305',
            'actionable': 'ABORT',
            'actionType': 'RETRIEVE_CMS_AIRPORTS',
            'errorMsg': response.error.message ? `${response.error.message} ${urlErrorEndpoint}` : `CMS_SERVICE_UNAVAILABLE ${urlErrorEndpoint}`,
            'errorExtraInfo': response.error.config.url ? response.error.config.url : 'Service Unavailable from CMS, please try again some minutes later',
          }),
        }));
      } else {
        dispatch(addAirportLite(response));
      }
    }).catch(error => {
      const urlErrorEndpoint = error.request && error.request.responseURL ? error.request.responseURL : null;
      dispatch(AirportsLiteFail(error));

      dispatch(sendAnalytics({
        eventCreator: errorTrackingFromCMS.errorFromCMS({
          'event': 'error',
          'type': 'ABORT',
          'statusCode': 503,
          'code': '12111305',
          'actionable': 'CONTINUE',
          'actionType': 'RETRIEVE_CMS_AIRPORTS',
          'errorMsg': error.message ? `${error.message} ${urlErrorEndpoint}` : `CMS_SERVICE_UNAVAILABLE ${urlErrorEndpoint}`,
          'errorExtraInfo': error.config.url ? error.config.url : 'Service Unavailable from CMS, please try again some minutes later',
        }),
      }));
    });
  };
}

export const AirportsLiteStart = () => ({
  type: asyncActionTypes.RETRIEVE_CMS_AIRPORTS_LITE.START,
});

export const addAirportLite = airportsLite => ({
  type: asyncActionTypes.RETRIEVE_CMS_AIRPORTS_LITE.SUCCESS,
  payload: airportsLite,
});

export const AirportsLiteFail = (error) => ({
  type: asyncActionTypes.RETRIEVE_CMS_AIRPORTS_LITE.FAIL,
  payload: error,
});

// Get Grant Access

export function getGrantAccess(loading) {
  return function action(dispatch) {
    dispatch(getGrantAccessStart(loading));

    // const request = getGrantAccessRequest(); // API
    const request = getAmGrant();
    request.then(response => {
      if (response && response.grantAccess) {
        dispatch(getGrantAccessSuccess(response));
      }

      if (response && response._meta && response._meta.class && response._meta.class === 'Incident') {
        errorApiGeeTracking(response, asyncActionTypes.GET_GRANT_ACCESS, 'amGrant', dispatch);
        dispatch(getGrantAccessFail(response));
      }
    }).catch(error => {
      dispatch(getGrantAccessFail(error));
    });
  };
}

export const getGrantAccessStart = (loading) => ({
  type: asyncActionTypes.GET_GRANT_ACCESS.START,
  payload: { grantAccessLoading: true, loading },
});

export const getGrantAccessSuccess = (response) => {
  return {
    type: asyncActionTypes.GET_GRANT_ACCESS.SUCCESS,
    payload: response,
  };
};

export const getGrantAccessFail = (error) => {
  return {
    type: asyncActionTypes.GET_GRANT_ACCESS.FAIL,
    payload: error,
  };
};

// COBRAND AFFILIATE
export function retrieveBannerCobrandAffiliate(language) {
  return function action(dispatch) {
    const request = getBannerCobrandAffiliate(language);

    dispatch(BannerCobrandAffiliateStart());

    request.then(response => {
      if (response.error) {
        const statusCode = response.error.response && response.error.response.status ? response.error.response.status : 503;
        const urlErrorEndpoint = response.error.request && response.error.request.responseURL ? response.error.request.responseURL : null;

        dispatch(BannerCobrandAffiliateFail(response.error));

        dispatch(sendAnalytics({
          eventCreator: errorTrackingFromCMS.errorFromCMS({
            'event': 'error',
            'type': 'WARNING',
            'statusCode': statusCode,
            'code': '13330903',
            'actionable': 'CONTINUE',
            'actionType': 'RETRIEVE_CMS_COBRANDCARD_AFFILIATE',
            'errorMsg': response.error.message ? `${response.error.message} ${urlErrorEndpoint}` : `CMS_SERVICE_UNAVAILABLE ${urlErrorEndpoint}`,
            'errorExtraInfo': response.error.config.url ? response.error.config.url : 'Service Unavailable from CMS, please try again some minutes later',
          }),
        }));
      } else {
        dispatch(addBannerCobrandAffiliate(response));
      }
    }).catch(error => {
      const urlErrorEndpoint = error.request && error.request.responseURL ? error.request.responseURL : null;
      dispatch(BannerCobrandAffiliateFail(error));

      dispatch(sendAnalytics({
        eventCreator: errorTrackingFromCMS.errorFromCMS({
          'event': 'error',
          'type': 'WARNING',
          'statusCode': 503,
          'code': '13330903',
          'actionable': 'CONTINUE',
          'actionType': 'RETRIEVE_CMS_COBRANDCARD_AFFILIATE',
          'errorMsg': error.message ? `${error.message} ${urlErrorEndpoint}` : `CMS_SERVICE_UNAVAILABLE ${urlErrorEndpoint}`,
          'errorExtraInfo': error.config.url ? error.config.url : 'Service Unavailable from CMS, please try again some minutes later',
        }),
      }));
    });
  };
}

export const BannerCobrandAffiliateStart = () => ({
  type: asyncActionTypes.RETRIEVE_CMS_COBRANDCARD_AFFILIATE.START,
});

export const addBannerCobrandAffiliate = BannerCobrandAffiliate => ({
  type: asyncActionTypes.RETRIEVE_CMS_COBRANDCARD_AFFILIATE.SUCCESS,
  payload: BannerCobrandAffiliate,
});

export const BannerCobrandAffiliateFail = (error) => ({
  type: asyncActionTypes.RETRIEVE_CMS_COBRANDCARD_AFFILIATE.FAIL,
  payload: error,
});

// Personalized Acquisition Cobrand
export function retrievePersonalizedAcquisitionCobrand(language) {
  return function action(dispatch) {
    const request = getPersonalizedAcquisitionCobrand(language);

    dispatch(PersonalizedAcquisitionCobrandStart());

    request.then(response => {
      if (response.error) {
        const statusCode = response.error.response && response.error.response.status ? response.error.response.status : 503;
        const urlErrorEndpoint = response.error.request && response.error.request.responseURL ? response.error.request.responseURL : null;

        dispatch(PersonalizedAcquisitionCobrandFail(response.error));

        dispatch(sendAnalytics({
          eventCreator: errorTrackingFromCMS.errorFromCMS({
            'event': 'error',
            'type': 'WARNING',
            'statusCode': statusCode,
            'code': '13330904',
            'actionable': 'CONTINUE',
            'actionType': 'RETRIEVE_CMS_PERSONALIZED_ACQUISITION_COBRAND',
            'errorMsg': response.error.message ? `${response.error.message} ${urlErrorEndpoint}` : `CMS_SERVICE_UNAVAILABLE ${urlErrorEndpoint}`,
            'errorExtraInfo': response.error.config.url ? response.error.config.url : 'Service Unavailable from CMS, please try again some minutes later',
          }),
        }));
      } else {
        dispatch(PersonalizedAcquisitionCobrandSuccess(response));
      }
    }).catch(error => {
      const urlErrorEndpoint = error.request && error.request.responseURL ? error.request.responseURL : null;
      dispatch(PersonalizedAcquisitionCobrandFail(error));

      dispatch(sendAnalytics({
        eventCreator: errorTrackingFromCMS.errorFromCMS({
          'event': 'error',
          'type': 'WARNING',
          'statusCode': 503,
          'code': '13330904',
          'actionable': 'CONTINUE',
          'actionType': 'RETRIEVE_CMS_PERSONALIZED_ACQUISITION_COBRAND',
          'errorMsg': error.message ? `${error.message} ${urlErrorEndpoint}` : `CMS_SERVICE_UNAVAILABLE ${urlErrorEndpoint}`,
          'errorExtraInfo': error.config.url ? error.config.url : 'Service Unavailable from CMS, please try again some minutes later',
        }),
      }));
    });
  };
}

export const PersonalizedAcquisitionCobrandStart = () => ({
  type: asyncActionTypes.RETRIEVE_CMS_PERSONALIZED_ACQUISITION_COBRAND.START,
});

export const PersonalizedAcquisitionCobrandSuccess = (response) => ({
  type: asyncActionTypes.RETRIEVE_CMS_PERSONALIZED_ACQUISITION_COBRAND.SUCCESS,
  payload: response,
});

export const PersonalizedAcquisitionCobrandFail = (error) => ({
  type: asyncActionTypes.RETRIEVE_CMS_PERSONALIZED_ACQUISITION_COBRAND.FAIL,
  payload: error,
});

// Personalization Sign Pop Up -----------------
export function retrieveInfoSignUpPopUp(language, section) {
  return function action(dispatch) {
    const request = getInfoSignUpPopUp(language, section);
    dispatch(InfoSignUpPopUpStart());
    request.then(response => {
      if (response.error) {
        const statusCode = response.error.response && response.error.response.status ? response.error.response.status : 503;
        const urlErrorEndpoint = response.error.request && response.error.request.responseURL ? response.error.request.responseURL : null;
        dispatch(InfoSignUpPopUpFail());
        dispatch(sendAnalytics({
          eventCreator: errorTrackingFromCMS.errorFromCMS({
            'event': 'error',
            'type': 'WARNING',
            'statusCode': statusCode,
            'code': '13330906',
            'actionable': 'CONTINUE',
            'actionType': 'RETRIEVE_CMS_INFO_SIGNUP_POPUP',
            'errorMsg': response.error.message ? `${response.error.message} ${urlErrorEndpoint}` : `CMS_SERVICE_UNAVAILABLE ${urlErrorEndpoint}`,
            'errorExtraInfo': response.error.config.url ? response.error.config.url : 'Service Unavailable from CMS, please try again some minutes later',
          }),
        }));
      } else {
        dispatch(InfoSignUpPopUpSuccess(response));
      }
    }).catch(error => {
      const urlErrorEndpoint = error.request && error.request.responseURL ? error.request.responseURL : null;
      dispatch(InfoSignUpPopUpFail(error));

      dispatch(sendAnalytics({
        eventCreator: errorTrackingFromCMS.errorFromCMS({
          'event': 'error',
          'type': 'WARNING',
          'statusCode': 503,
          'code': '13330906',
          'actionable': 'CONTINUE',
          'actionType': 'RETRIEVE_CMS_INFO_SIGNUP_POPUP',
          'errorMsg': error.message ? `${error.message} ${urlErrorEndpoint}` : `CMS_SERVICE_UNAVAILABLE ${urlErrorEndpoint}`,
          'errorExtraInfo': error.config.url ? error.config.url : 'Service Unavailable from CMS, please try again some minutes later',
        }),
      }));
    });
  };
}

export const InfoSignUpPopUpStart = () => ({
  type: asyncActionTypes.RETRIEVE_INFO_SIGNUP_POPUP.START,
  payload: [],
});

export const InfoSignUpPopUpSuccess = (response) => ({
  type: asyncActionTypes.RETRIEVE_INFO_SIGNUP_POPUP.SUCCESS,
  payload: response || [],
});

export const InfoSignUpPopUpFail = (error) => ({
  type: asyncActionTypes.RETRIEVE_INFO_SIGNUP_POPUP.FAIL,
  payload: error,
});

export const activatePersistentLoginPopup = () => ({
  type: ACTIVATE_PERSISTENT_LOGIN_POPUP,
});

export const disablePersistentLoginPopup = () => ({
  type: DISABLE_PERSISTENT_LOGIN_POPUP,
});

export const resetCPnumber = () => ({
  type: RESET_CP_NUMBER,
});

export const resetLoginSuccessCount = () => ({
  type: RESET_LOGIN_SUCCESS_COUNT,
});

export const setSignInState = () => ({
  type: SET_SIGN_IN_STATE,
});

// BrandedBenefits
export function retrieveBrandedBenefits(market, region, language) {
  return function action(dispatch) {
    const request = getBrandedBenefits(market, region, language);
    dispatch(BrandedBenefitsStart());
    request.then(response => {
      if (response.error) {
        dispatch(BrandedBenefitsFail(response.error));
        dispatch(sendAnalytics({
          eventCreator: errorTrackingFromCMS.errorFromCMS({
            'event': 'error',
            'type': 'WARNING',
            'statusCode': 503,
            'code': '14330901',
            'actionable': 'CONTINUE',
            'actionType': 'RETRIEVE_CMS_BRANDED_BENEFITS',
            'errorMsg': response.error.config.url ? response.error.config.url : 'CMS_SERVICE_UNAVAILABLE',
            'errorExtraInfo': response.error.config.url ? response.error.config.url : 'Service Unavailable from CMS, please try again some minutes later',
          }),
        }));
      } else {
        dispatch(BrandedBenefitsSuccess(response));
      }
    }).catch(error => {
      const urlErrorEndpoint = error.request && error.request.responseURL ? error.request.responseURL : null;
      dispatch(BrandedBenefitsFail(error));
      dispatch(sendAnalytics({
        eventCreator: errorTrackingFromCMS.errorFromCMS({
          'event': 'error',
          'type': 'WARNING',
          'statusCode': 503,
          'code': '14330901',
          'actionable': 'CONTINUE',
          'actionType': 'RETRIEVE_CMS_BRANDED_BENEFITS',
          'errorMsg': error.message ? `${error.message} ${urlErrorEndpoint}` : `CMS_SERVICE_UNAVAILABLE ${urlErrorEndpoint}`,
          'errorExtraInfo': error.config.url ? error.config.url : 'Service Unavailable from CMS, please try again some minutes later',
        }),
      }));
    });
  };
}

export const BrandedBenefitsStart = () => ({
  type: asyncActionTypes.RETRIEVE_CMS_BRANDED_BENEFITS.START,
});

export const BrandedBenefitsSuccess = (response) => ({
  type: asyncActionTypes.RETRIEVE_CMS_BRANDED_BENEFITS.SUCCESS,
  payload: response,
});

export const BrandedBenefitsFail = (error) => ({
  type: asyncActionTypes.RETRIEVE_CMS_BRANDED_BENEFITS.FAIL,
  payload: error,
});

export function retrieveTouchPoints(language) {
  return function action(dispatch) {
    const request = getInfoTouchPoints(language);

    dispatch(InfoTouchPointsStart());

    request.then(response => {
      if (response.error) {
        const statusCode = response.error.response && response.error.response.status ? response.error.response.status : 503;
        const urlErrorEndpoint = response.error.request && response.error.request.responseURL ? response.error.request.responseURL : null;

        dispatch(InfoTouchPointsFail());

        dispatch(sendAnalytics({
          eventCreator: errorTrackingFromCMS.errorFromCMS({
            'event': 'error',
            'type': 'WARNING',
            'statusCode': statusCode,
            'code': '17330908',
            'actionable': 'CONTINUE',
            'actionType': 'RETRIEVE_TOUCHPOINTS_LOGIN',
            'errorMsg': response.error.message ? `${response.error.message} ${urlErrorEndpoint}` : `CMS_SERVICE_UNAVAILABLE ${urlErrorEndpoint}`,
            'errorExtraInfo': response.error.config.url ? response.error.config.url : 'Service Unavailable from CMS, please try again some minutes later',
          }),
        }));
      } else {
        dispatch(InfoTouchPointsSuccess(response));
      }
    }).catch(error => {
      const urlErrorEndpoint = error.request && error.request.responseURL ? error.request.responseURL : null;

      dispatch(InfoTouchPointsFail(error));

      dispatch(sendAnalytics({
        eventCreator: errorTrackingFromCMS.errorFromCMS({
          'event': 'error',
          'type': 'WARNING',
          'statusCode': 503,
          'code': '17330908',
          'actionable': 'CONTINUE',
          'actionType': 'RETRIEVE_TOUCHPOINTS_LOGIN',
          'errorMsg': error.message ? `${error.message} ${urlErrorEndpoint}` : `CMS_SERVICE_UNAVAILABLE ${urlErrorEndpoint}`,
          'errorExtraInfo': error.config.url ? error.config.url : 'Service Unavailable from CMS, please try again some minutes later',
        }),
      }));
    });
  };
}

export const InfoTouchPointsStart = () => ({
  type: asyncActionTypes.RETRIEVE_TOUCHPOINTS_LOGIN.START,
  payload: [],
});

export const InfoTouchPointsSuccess = (response) => ({
  type: asyncActionTypes.RETRIEVE_TOUCHPOINTS_LOGIN.SUCCESS,
  payload: response,
});

export const InfoTouchPointsFail = (error) => ({
  type: asyncActionTypes.RETRIEVE_TOUCHPOINTS_LOGIN.FAIL,
  payload: error,
});

export const setStatusActiveFlowCorporate = (status) => {
  return {
    type: asyncActionTypes.SET_FLOW_CORPORATE.START,
    payload: status,
  };
};

/** ACTIONS CORPORATE */
export function setFlowCorporateIsActive(status) {
  return function action(dispatch) {
    dispatch(setStatusActiveFlowCorporate(status));
  };
}

export function setCorporateSupplierSelected(supplier) {
  return {
    type: asyncActionTypes.SET_CORPORATE_SUPPLIER_SELECTED,
    supplier,
  };
}

export const setSwitchFlowCorporate = (status) => {
  return {
    type: asyncActionTypes.CHANGE_SWITCH_FLOW.START,
    payload: status,
  };
};

export const setSwitchFlowCorporateIsActive = (status) => (dispatch) => {
  dispatch(setSwitchFlowCorporate(status));
};

export const setCompanySelectedCorporate = (name) => {
  return {
    type: asyncActionTypes.SET_NAME_COMPANY.START,
    payload: name,
  };
};

export const setCompanySelected = (name) => (dispatch) => {
  dispatch(setCompanySelectedCorporate(name));
};

// // MODALES CORPORATIVOS
export const setChangeCorporateFlow = (status) => {
  return {
    type: asyncActionTypes.CHANGE_CORPORATE_FLOW.START,
    payload: status,
  };
};

export const changeCorporateFlow = (status) => (dispatch) => {
  dispatch(setChangeCorporateFlow(status));
};

export const setChangeCorporateCompany = (status) => {
  return {
    type: asyncActionTypes.CHANGE_CORPORATE_COMPANY.START,
    payload: status,
  };
};

export const changeCorporateCompany = (status) => (dispatch) => {
  dispatch(setChangeCorporateCompany(status));
};

export const setLoginCorporate = (status) => {
  return {
    type: asyncActionTypes.LOGIN_CORPORATE.START,
    payload: status,
  };
};

export function loginCorporate(status) {
  return function action(dispatch) {
    dispatch(setLoginCorporate(status));
  };
}

export const closeModalCorporateAction = () => {
  return {
    type: asyncActionTypes.CLOSE_MODAL_CORPORATE.START,
  };
};

export const openModalCorporate = () => {
  return {
    type: asyncActionTypes.OPEN_MODAL_CORPORATE.START,
  };
};

export function closeModalCorporate() {
  return function action(dispatch) {
    dispatch(closeModalCorporateAction());
  };
}

export const setRetrieveCorporateData = (status) => {
  return {
    type: asyncActionTypes.RETRIEVE_CORPORATE_PROFILE_DATA.START,
    payload: status,
  };
};

export function retrieveCorporateData(status) {
  return function action(dispatch) {
    dispatch(setLoginCorporate(status));
  };
}
/** END ACTIONS CORPORATE */

export function updateTermsConsentCp(data) {
  return function action(dispatch) {
    const request = updateConsentCp(data);
    dispatch(updateTermsConsentCpStart());

    request.then(response => {
      if (response && response.grantAccess) {
        dispatch(updateTermsConsentCpSuccess(response));
      }

      if (response?.updateConsentWSCommand?.success) {
        dispatch(sendAnalytics({
          eventCreator: manageTracking.updateConsentCp({
            eventAction: 'Acepted',
            eventLabel: 'Success',
          }),
        }));

        dispatch(activeBannerUpdateConsent(true, true));
      } else if (response && ((!response?.updateConsentWSCommand?.success) || response.description || response.errorDescription || response.status)) {
        const errorInfo = {
          actionType: 'UPDATE_CONSENT_CP',
          errorData: {
            actionable: actionableCodes.RETRY,
            code: `${response.errorCode || response.code}|${response.httpStatus || response.status}|UPDATE_CONSENT_CP`,
            msg: (response.description) ? response.description : 'Hubo un error al asentar el consent en Club Premier',
            extraInfo: {
              'debugging_stuff_here': response.errorDescription ? response.errorDescription : 'Servicios Club Premier',
            },
          },
        };

        dispatch(activeBannerUpdateConsent(true, false));

        dispatch(sendAnalytics({
          eventCreator: manageTracking.updateConsentCp({
            eventAction: 'Acepted',
            eventLabel: response.errorCode ? 'Fail - errorDeConexion' : 'Fail - error404',
          }),
        }));

        dispatch(sendAnalytics({
          eventCreator: errorTracking.errorTracking(errorInfo),
        }));

        dispatch(updateTermsConsentCpFail(response));
      }
    }).catch(error => {
      dispatch(updateTermsConsentCpFail(error));
    });
  };
}

export const updateTermsConsentCpStart = () => ({
  type: asyncActionTypes.UPDATE_CONSENT_CP.START,
});

export const updateTermsConsentCpSuccess = (response) => {
  return {
    type: asyncActionTypes.UPDATE_CONSENT_CP.SUCCESS,
    payload: response,
  };
};

export const updateTermsConsentCpFail = (error) => {
  return {
    type: asyncActionTypes.UPDATE_CONSENT_CP.FAIL,
    payload: error,
  };
};

export const updateCountErrorPayment = () => ({
  type: asyncActionTypes.COUNT_ERROR_PAYMENT.FAIL,
});

export const updateCartSessionData = sessionData => {
  return {
    type: asyncActionTypes.UPDATE_CART_SESSION_DATA.SUCCESS,
    payload: sessionData,
  };
};


export function getSessionData(body) {
  return function action(dispatch) {
    dispatch(updateSessionDataOnSuccess(body));
  };
}

export const updateSessionDataOnStart = () => {
  return {
    type: asyncActionTypes.UPDATE_CART_SESSION_DATA.START,
  };
};
export const updateSessionDataOnSuccess = sessionData => {
  return {
    type: asyncActionTypes.UPDATE_CART_SESSION_DATA.SUCCESS,
    payload: sessionData,
  };
};
export const updateSessionDataOnFail = () => {
  return {
    type: asyncActionTypes.UPDATE_CART_SESSION_DATA.FAIL,
  };
};
export const setSessionModalClosed = () => {
  return {
    type: asyncActionTypes.SET_IS_CART_SESSION_MODAL_CLOSED.SUCCESS,
  };
};
export const setSessionModalOpen = () => {
  return {
    type: asyncActionTypes.SET_IS_CART_SESSION_MODAL_OPEN.SUCCESS,
  };
};

export function openSessionModal() {
  return function action(dispatch) {
    dispatch(setSessionModalOpen());
  };
}
export function closeSessionModal() {
  return function action(dispatch) {
    dispatch(setSessionModalClosed());
  };
}

export function continueSession(body) {
  return function action(dispatch) {
    const sessionRequest = getSessionStatus(body);
    sessionRequest.then(response => {
      dispatch(getSessionData(response.data));
      dispatch(closeSessionModal());
    }
    );
  };
}
export function sendAncillaryReject(data) {
  return sendAncillaryRejectEvent(data);
}

export function getContactabilityTokenData(data) {
  return function action(dispatch) {
    dispatch(getContactabilityTokenDataOnStart);
    getBearerTokenContactability()
      .then((response) => {
        return saveContactabilityDigital(data, response?.message);
      })
      .then((result) => {
        return result?.data;
      })
      .catch(() => {
        dispatch(getContactabilityTokenDataOnFail);
      });
  };
}
export const getContactabilityTokenDataOnStart = () => {
  return {
    type: asyncActionTypes.GET_CONTACTABILITY_TOKEN.START,
  };
};
export const getContactabilityTokenDatanSuccess = data => {
  return {
    type: asyncActionTypes.GET_CONTACTABILITY_TOKEN.SUCCESS,
    payload: data,
  };
};
export const getContactabilityTokenDataOnFail = () => {
  return {
    type: asyncActionTypes.GET_CONTACTABILITY_TOKEN.FAIL,
  };
};

// RefundReason
export function retrieveRefundReason(subCodes, language, quoteOrFulfill) {
  return function action(dispatch) {
    if (subCodes === '') {
      dispatch(RefundReasonStart());
      dispatch(RefundReasonSuccess([], quoteOrFulfill));
    } else {
      const request = getRefundReason(subCodes, language);
      dispatch(RefundReasonStart());
      request.then(response => {
        if (response.error) {
          dispatch(RefundReasonFail(response.error));
          dispatch(sendAnalytics({
            eventCreator: errorTrackingFromCMS.errorFromCMS({
              'event': 'error',
              'type': 'WARNING',
              'statusCode': 503,
              'code': '13330911|503|RETRIEVE_REFUND_REASON',
              'actionable': 'CONTINUE',
              'actionType': 'RETRIEVE_REFUND_REASON',
              'errorMsg': response?.error?.config?.url ? response?.error?.config?.url : 'CMS_SERVICE_UNAVAILABLE',
              'errorExtraInfo': response?.error?.config?.url ? response?.error?.config?.url : 'Service Unavailable from CMS, please try again some minutes later',
            }),
          }));
        } else {
          dispatch(RefundReasonSuccess(response, quoteOrFulfill));
        }
      }).catch(error => {
        const urlErrorEndpoint = error?.request?.responseURL || null;
        dispatch(RefundReasonFail(error));
        dispatch(sendAnalytics({
          eventCreator: errorTrackingFromCMS.errorFromCMS({
            'event': 'error',
            'type': 'WARNING',
            'statusCode': 503,
            'code': '13330911|503|RETRIEVE_REFUND_REASON',
            'actionable': 'CONTINUE',
            'actionType': 'RETRIEVE_REFUND_REASON',
            'errorMsg': error.message ? `${error.message} ${urlErrorEndpoint}` : `CMS_SERVICE_UNAVAILABLE ${urlErrorEndpoint}`,
            'errorExtraInfo': error?.config?.url ? error?.config?.url : 'Service Unavailable from CMS, please try again some minutes later',
          }),
        }));
      });
    }
  };
}

export const RefundReasonStart = () => ({
  type: asyncActionTypes.RETRIEVE_REFUND_REASON.START,
});

export const RefundReasonSuccess = (response, quoteOrFulfill) => ({
  type: asyncActionTypes.RETRIEVE_REFUND_REASON.SUCCESS,
  payload: response,
  quoteOrFulfill: quoteOrFulfill,
});

export const RefundReasonFail = (error) => ({
  type: asyncActionTypes.RETRIEVE_REFUND_REASON.FAIL,
  payload: error,
});

export function sendRefundInfoToSalesforce(refundInfo) {
  return function action(dispatch) {
    dispatch(RefundInfoToSalesforceStart());
    const request = sendRefundInfoToSalesforceApi(refundInfo);

    request.then(response => {
      if (response?.status >= 400 || response === null || response === undefined) {
        dispatch(RefundInfoToSalesforceFail(response));
        dispatch(
          sendAnalytics({
            eventCreator: errorTracking.errorTracking({
              actionType: 'REFUND_INFO_TO_SALESFORCE',
              errorData: {
                actionable: 'ABORT',
                code: `${response?.code}|${response?.status}|REFUND_INFO_TO_SALESFORCE`,
                msg: response?.message?.message,
                extraInfo: {
                  'debugging_stuff_here': response?.messageServer?.error?.[0]?.description,
                },
              },
            }),
          })
        );
      } else {
        dispatch(RefundInfoToSalesforceSuccess(response));
      }
    }).catch(error => {
      dispatch(RefundInfoToSalesforceFail(error));
      dispatch(
        sendAnalytics({
          eventCreator: errorTracking.errorTracking({
            actionType: 'REFUND_INFO_TO_SALESFORCE',
            errorData: {
              actionable: 'ABORT',
              code: `${error?.code}|${error?.status}|REFUND_INFO_TO_SALESFORCE`,
              msg: error?.message,
              extraInfo: {
                'debugging_stuff_here': error?.message,
              },
            },
          }),
        })
      );
    });
  };
}

export const RefundInfoToSalesforceStart = () => ({
  type: asyncActionTypes.REFUND_INFO_TO_SALESFORCE.START,
});

export const RefundInfoToSalesforceSuccess = (response) => ({
  type: asyncActionTypes.REFUND_INFO_TO_SALESFORCE.SUCCESS,
  payload: response,
});

export const RefundInfoToSalesforceFail = (error) => ({
  type: asyncActionTypes.REFUND_INFO_TO_SALESFORCE.FAIL,
  payload: error,
});

// Send successful refund info to Salesforce
export function sendSuccessfulRefundToSalesForce(refundInfo) {
  return function action(dispatch) {
    dispatch(SendSuccessToSalesforceStart());
    const request = sendRefundInfoToSalesforceApi(refundInfo);

    request.then(response => {
      if (response?.status >= 400 || response === null || response === undefined) {
        dispatch(SendSuccessToSalesforceFail(response));
        dispatch(
          sendAnalytics({
            eventCreator: errorTracking.errorTracking({
              actionType: 'SEND_SUCCESS_TO_SALESFORCE',
              errorData: {
                actionable: 'ABORT',
                code: `${response?.code}|${response?.status}|SEND_SUCCESS_TO_SALESFORCE`,
                msg: response?.message?.message,
                extraInfo: {
                  'debugging_stuff_here': response?.messageServer?.error?.[0]?.description,
                },
              },
            }),
          })
        );
      } else {
        dispatch(SendSuccessToSalesforceSuccess(response));
      }
    }).catch(error => {
      dispatch(SendSuccessToSalesforceFail(error));
      dispatch(
        sendAnalytics({
          eventCreator: errorTracking.errorTracking({
            actionType: 'SEND_SUCCESS_TO_SALESFORCE',
            errorData: {
              actionable: 'ABORT',
              code: `${error?.code}|${error?.status}|SEND_SUCCESS_TO_SALESFORCE`,
              msg: error?.message,
              extraInfo: {
                'debugging_stuff_here': error?.message,
              },
            },
          }),
        })
      );
    });
  };
}

export const SendSuccessToSalesforceStart = () => ({
  type: asyncActionTypes.SEND_SUCCESS_TO_SALESFORCE.START,
});

export const SendSuccessToSalesforceSuccess = (response) => ({
  type: asyncActionTypes.SEND_SUCCESS_TO_SALESFORCE.SUCCESS,
  payload: response,
});

export const SendSuccessToSalesforceFail = (error) => ({
  type: asyncActionTypes.SEND_SUCCESS_TO_SALESFORCE.FAIL,
  payload: error,
});

// PassengerListForRefund
export function UpdateDocumentNumbers(documentNumbers) {
  return function action(dispatch) {
    dispatch(UpdateDocumentNumbersStart());
    if (documentNumbers.length > 0) {
      dispatch(UpdateDocumentNumbersSuccess(documentNumbers));
    } else {
      dispatch(UpdateDocumentNumbersFail());
    }
  };
}

export const UpdateDocumentNumbersStart = () => ({
  type: asyncActionTypes.UPDATE_DOCUMENT_NUMBERS.START,
});

export const UpdateDocumentNumbersSuccess = (documentNumbers) => ({
  type: asyncActionTypes.UPDATE_DOCUMENT_NUMBERS.SUCCESS,
  payload: documentNumbers,
});

export const UpdateDocumentNumbersFail = () => ({
  type: asyncActionTypes.UPDATE_DOCUMENT_NUMBERS.FAIL,
});

// G tickets list
export function UpdateGDocumentNumbers(documentNumbers) {
  return function action(dispatch) {
    dispatch(UpdateGDocumentNumbersStart());
    if (documentNumbers.length > 0) {
      dispatch(UpdateGDocumentNumbersSuccess(documentNumbers));
    } else {
      dispatch(UpdateGDocumentNumbersFail());
    }
  };
}

export const UpdateGDocumentNumbersStart = () => ({
  type: asyncActionTypes.UPDATE_G_DOCUMENT_NUMBERS.START,
});

export const UpdateGDocumentNumbersSuccess = (documentNumbers) => ({
  type: asyncActionTypes.UPDATE_G_DOCUMENT_NUMBERS.SUCCESS,
  payload: documentNumbers,
});

export const UpdateGDocumentNumbersFail = () => ({
  type: asyncActionTypes.UPDATE_G_DOCUMENT_NUMBERS.FAIL,
});

// Set refund for code 96.5
export function setRefundForCode96Dot5(setRefund = false) {
  return function action(dispatch) {
    dispatch(setRefundForCode96Dot5Start());
    if (setRefund) {
      dispatch(setRefundForCode96Dot5Success(setRefund));
    } else {
      dispatch(setRefundForCode96Dot5Fail());
    }
  };
}

export const setRefundForCode96Dot5Start = () => ({
  type: asyncActionTypes.SET_REFUND_CODE_96_5.START,
});

export const setRefundForCode96Dot5Success = (setRefund) => ({
  type: asyncActionTypes.SET_REFUND_CODE_96_5.SUCCESS,
  payload: setRefund,
});

export const setRefundForCode96Dot5Fail = () => ({
  type: asyncActionTypes.SET_REFUND_CODE_96_5.FAIL,
});

export function getUpgradeVoucher(data) {
  return function action(dispatch) {
    const request = retrieveUpgradeVoucher(data);
    dispatch(retreiveUpdagradeVoucherStart());

    request.then(response => {
      if (response?.upgrades) {
        dispatch(retreiveUpdagradeVoucherSuccess(response));
      } else {
        dispatch(retreiveUpdagradeVoucherFail(response));
      }
    }).catch(error => {
      dispatch(retreiveUpdagradeVoucherFail(error));
    });
  };
}

export const retreiveUpdagradeVoucherStart = () => ({
  type: asyncActionTypes.RETRIEVE_UPGRADE_VOUCHER.START,
});

export const retreiveUpdagradeVoucherSuccess = (response) => ({
  type: asyncActionTypes.RETRIEVE_UPGRADE_VOUCHER.SUCCESS,
  payload: response,
});

export const retreiveUpdagradeVoucherFail = (error) => ({
  type: asyncActionTypes.RETRIEVE_UPGRADE_VOUCHER.FAIL,
  payload: error,
});

export function submitUpgradeVoucherRedeem(dataReq) {
  return function action(dispatch) {
    const request = submitUpgradeVouchers(dataReq);
    dispatch(setUpdagradeVoucherStart());

    request.then(response => {
      const {
        code = '',
        data = {},
        event = '',
      } = response;

      if (Boolean(data?.upgrades)) {
        const computedResponse = computeUpgradeVouchers(response);
        const {
          error = {},
          unredeemedVouchers = [],
          voucherRedeemed = [],
        } = computedResponse || {};

        if (voucherRedeemed?.length) {
          storage.set('upgradeVoucher', true);
          const vouchers = {
            unredeemedVouchers,
            voucherRedeemed,
          };
          dispatch(setUpdagradeVoucherSuccess(vouchers, dataReq, data));
        } else {
          dispatch(setUpdagradeVoucherFail(error, dataReq, data));
        }
      } else if (Boolean(event === 'error' && code) ) {
        dispatch(setUpdagradeVoucherFail(response, dataReq, data));
      }
    }).catch(error => {
      dispatch(setUpdagradeVoucherFail(error, dataReq, error));
    });
  };
}

function computeUpgradeVouchers(response) {
  const upgrades = response?.data?.upgrades || [];
  const voucherRedeemed = upgrades.filter(v => v.success && Boolean(v.ticketNumber) && !Boolean(v.reason));
  const unRedeemedFilter = (v) => !v.success || (v.success && (!Boolean(v.ticketNumber) || Boolean(v.reason)));
  const unredeemedVouchers = upgrades.filter(unRedeemedFilter);

  if (!upgrades.length || (!voucherRedeemed.length && !unredeemedVouchers.length)) {
    const error = {
      'event': 'error',
      'type': 'NA',
      'statusCode': 200, // Vine del API
      'code': 'NA', // Vine del API
      'actionType': 'NA',
      'actionable': 'ABORT', // Viene de CMS
      'errorMsg': 'NA', // Viene de CMS, sino está cargado se vá como NA
      'errorExtraInfo': `WEB|${response?.config?.headers?.flow}-status`, // El web es por default, el flow se toma del header request
      'errorUrl': window.location.pathname,  // Toma la ruta del urlPath
      'codeAction': 'abortModal', // Viene de cms
    };
    return {
      error,
      unredeemedVouchers: [],
      voucherRedeemed: [],
    };
  } else if (upgrades.length > 0 && unredeemedVouchers.length === upgrades.length) {
    const errorCms = getCmsErrorUpgradeVoucher(unredeemedVouchers);
    const {
      actionable,
      id,
      title,
      type,
    } = upgradeVoucherErrors[errorCms];

    const error = {
      'event': 'error',
      'type': 'NA',
      'statusCode': response?.status, // Vine del API
      'code': id, // Vine del API
      'actionType': 'NA',
      'actionable': actionable || 'ABORT', // Viene de CMS
      'errorMsg': title, // Viene de CMS, sino está cargado se vá como NA
      'errorExtraInfo': `WEB|${response?.config?.headers?.flow}-status`, // El web es por default, el flow se toma del header request
      'errorUrl': window.location.pathname,  // Toma la ruta del urlPath
      'codeAction': type, // Viene de cms
      unredeemedVouchers,
    };
    return {
      error,
      unredeemedVouchers: [],
      voucherRedeemed: [],
    };
  } else if (voucherRedeemed.length > 0) {
    return {
      unredeemedVouchers,
      voucherRedeemed,
    };
  }
}

export const setUpdagradeVoucherStart = () => ({
  type: asyncActionTypes.SET_UPGRADE_VOUCHER.START,
});

export const setUpdagradeVoucherSuccess = (vouchers, request, response) => ({
  type: asyncActionTypes.SET_UPGRADE_VOUCHER.SUCCESS,
  payload: vouchers,
  request,
  responseFromApi: response,
});

export const setUpdagradeVoucherFail = (error, request, response) => ({
  type: asyncActionTypes.SET_UPGRADE_VOUCHER.FAIL,
  payload: error,
  request,
  responseFromApi: response,
});

export function retrieveSessionTM() {
  return function action(dispatch) {
    const request = getUserSessionTM();

    dispatch(getUserSessionTMStart());

    request.then(response => {
      if (response.error) {
        dispatch(getUserSessionTMFail(response.error));
      } else {
        dispatch(getUserSessionTMSuccess(response));
      }
    }).catch(error => {
      dispatch(getUserSessionTMFail(error));
    });
  };
}

export const getUserSessionTMStart = () => ({
  type: asyncActionTypes.RETRIEVE_CP_SESSION_TM.START,
});

export const getUserSessionTMSuccess = (response) => ({
  type: asyncActionTypes.RETRIEVE_CP_SESSION_TM.SUCCESS,
  payload: response,
});

export const getUserSessionTMFail = (error) => ({
  type: asyncActionTypes.RETRIEVE_CP_SESSION_TM.FAIL,
  payload: error,
});

export function resendOtpLogin(data) {
  return function action(dispatch) {
    const request = submitUserResendOTPLogin(data);

    dispatch(submitUserResendOTPLoginStart());

    request.then(response => {
      if (response.error) {
        dispatch(submitUserResendOTPLoginFail(response.error));
      } else {
        dispatch(submitUserResendOTPLoginSuccess(response));
      }
    }).catch(error => {
      dispatch(submitUserResendOTPLoginFail(error));
    });
  };
}

export const submitUserResendOTPLoginStart = () => ({
  type: asyncActionTypes.RETRIEVE_CP_RESEND_OTP_LOGIN.START,
});

export const submitUserResendOTPLoginSuccess = (response) => ({
  type: asyncActionTypes.RETRIEVE_CP_RESEND_OTP_LOGIN.SUCCESS,
  payload: response,
});

export const submitUserResendOTPLoginFail = (error) => ({
  type: asyncActionTypes.RETRIEVE_CP_RESEND_OTP_LOGIN.FAIL,
  payload: error,
});

export function retrieveIpAddress() {
  return function action(dispatch) {
    const request = fetchIp();

    request.then(response => {
      if (response !== undefined) {
        dispatch(retrieveIpAddressSuccess(response));
      }
    }).catch(error => {
      console.log(error); // eslint-disable-line no-console
    }
    );
  };
}

export const retrieveIpAddressSuccess = (response) => ({
  type: asyncActionTypes.RETRIEVE_IP_ADDRESS,
  payload: response,
});

export function sendRecoverAccount(data) {
  return function action(dispatch) {
    const request = postRecoverAccount(data);
    dispatch(recoverAccountStart());

    request.then(response => {
      if (response?._meta?.class === 'Incident') {
        dispatch(recoverAccountFail(response));
      } else if (Object.keys(response).length === 0) {
        dispatch(recoverAccountSuccess(response));
      } else {
        dispatch(recoverAccountFail(response));
      }
    }).catch(error => {
      dispatch(recoverAccountFail(error));
    });
  };
}

export const recoverAccountStart = () => ({
  type: asyncActionTypes.RECOVER_ACCOUNT.START,
});

export const recoverAccountSuccess = (response) => ({
  type: asyncActionTypes.RECOVER_ACCOUNT.SUCCESS,
  payload: response,
});

export const recoverAccountFail = (error) => ({
  type: asyncActionTypes.RECOVER_ACCOUNT.FAIL,
  payload: error,
});

export const recoverAccountReset = () => ({
  type: asyncActionTypes.RECOVER_ACCOUNT.FAIL,
  payload: null,
  reset: true,
});

/**
 * Funcion para restablecimiento de Passwonrd y PIN telefonico
 */
export function sendRecoverAccountPasswordPin(data) {
  return function action(dispatch) {
    const {
      passwordPin,
      ...rest
    } = data;

    const request = otpSettings(rest);
    if (!passwordPin) {
      dispatch(recoverOtpSettingsStart());
    } else {
      dispatch(submitAccountPasswordPinStart());
    }

    request.then(response => {
      if (response?._meta?.class === 'Incident') {
        setFailOtpResponse(response, passwordPin, dispatch, rest);
      } else if (response?.maskedEmail) {
        if (!passwordPin) {
          dispatch(recoverOtpSettingsSuccess(response));
        } else if (passwordPin) {
          dispatch(recoverOtpSettingsFail(null));
          dispatch(submitAccountPasswordPinSuccess({ response, rest }));
        }
      } else {
        setFailOtpResponse(response, passwordPin, dispatch, rest);
      }
    }).catch(error => {
      setFailOtpResponse(error, passwordPin, dispatch);
    });
  };
}

function setFailOtpResponse(error, passwordPin, dispatch, request) {
  if (!passwordPin) {
    dispatch(recoverOtpSettingsFail(error));
  } else {
    dispatch(submitAccountPasswordPinFail({ error, request }));
  }
}

// Sumbit OTP Settings
export const recoverOtpSettingsStart = () => ({
  type: asyncActionTypes.RECOVER_OTP_SETTINGS.START,
});

export const recoverOtpSettingsSuccess = (response) => ({
  type: asyncActionTypes.RECOVER_OTP_SETTINGS.SUCCESS,
  payload: response,
});

export const recoverOtpSettingsFail = (error) => ({
  type: asyncActionTypes.RECOVER_OTP_SETTINGS.FAIL,
  payload: error,
});

export const recoverOtpSettingsReset = () => ({
  type: asyncActionTypes.RECOVER_OTP_SETTINGS.FAIL,
  payload: null,
  reset: true,
});

// Sumbit reuest to change Password/PIN
export const submitAccountPasswordPinStart = () => ({
  type: asyncActionTypes.SET_ACCOUNT_PASSWORD_PIN.START,
});

export const submitAccountPasswordPinSuccess = (response) => ({
  type: asyncActionTypes.SET_ACCOUNT_PASSWORD_PIN.SUCCESS,
  payload: response,
});

export const submitAccountPasswordPinFail = (error) => ({
  type: asyncActionTypes.SET_ACCOUNT_PASSWORD_PIN.FAIL,
  payload: error,
});

export const submitAccountPasswordPinReset = () => ({
  type: asyncActionTypes.SET_ACCOUNT_PASSWORD_PIN.FAIL,
  payload: null,
  reset: true,
});

// Association FFN
export function setFFNAssociation(data, associationMethod = '') {
  return function action(dispatch) {
    const request = ffnAssociation(data);

    dispatch(submitFFNAssociationStart());

    const fromApiModelData = transformAssociationFFnumber.fromApiModel(data);

    request.then(response => {
      if (response?._meta?.class === 'Incident') {
        dispatch(submitFFNAssociationFail(response, fromApiModelData, data, associationMethod));
      } else {
        dispatch(submitFFNAssociationSuccess(fromApiModelData, data, associationMethod));
      }
    }).catch(error => {
      dispatch(submitFFNAssociationFail(error, fromApiModelData, data, associationMethod));
    });
  };
}

export const submitFFNAssociationStart = () => ({
  type: asyncActionTypes.FFN_ASSOCIATION_MICRO.START,
});

export function submitFFNAssociationSuccess(response, data, associationMethod) {
  return {
    type: asyncActionTypes.FFN_ASSOCIATION_MICRO.SUCCESS,
    payload: response,
    request: data,
    associationMethod,
  };
}

export const submitFFNAssociationFail = (error, fromApiModelData, data, associationMethod) => ({
  type: asyncActionTypes.FFN_ASSOCIATION_MICRO.FAIL,
  payload: error,
  fromApiModelData,
  request: data,
  associationMethod,
});

// getBalance
export function myBalance(data, token, subflow = '') {
  return function action(dispatch) {
    const request = getBalance(data, token);

    dispatch(getBalanceStart());

    request.then(response => {
      if (response?._meta?.class === 'Incident') {
        dispatch(getBalanceFail(response, subflow));
      } else {
        dispatch(getBalanceSuccess(response, subflow));
      }
    }).catch(error => {
      dispatch(getBalanceFail(error, subflow));
    });
  };
}

export const getBalanceStart = () => ({
  type: asyncActionTypes.GET_BALANCE_MICRO.START,
});

export const getBalanceSuccess = (response, subflow) => ({
  type: asyncActionTypes.GET_BALANCE_MICRO.SUCCESS,
  payload: response,
  subflow,
});

export const getBalanceFail = (error, subflow) => ({
  type: asyncActionTypes.GET_BALANCE_MICRO.FAIL,
  payload: error,
  subflow,
});

export function getBenefitsCoreByPassengers(data) {
  return function action(dispatch) {
    const request = getBenefitsCoreApi(data);

    dispatch(getBenefitsCoreStart());

    request.then(response => {
      if (response?._meta?.class === 'Incident' || response.status == 503 || response.status == 500 || response.status == 400) {
        dispatch(getBenefitsCoreFail(response));
      } else {
        dispatch(getBenefitsCoreSuccess(response));
      }
    }).catch(error => {
      dispatch(getBenefitsCoreFail(error));
    });
  };
}

export const getBenefitsCoreStart = () => ({
  type: asyncActionTypes.RETRIEVE_BENEFITS_CORE.START,
});

export const getBenefitsCoreSuccess = (response) => ({
  type: asyncActionTypes.RETRIEVE_BENEFITS_CORE.SUCCESS,
  payload: response,
});

export const getBenefitsCoreFail = (error) => ({
  type: asyncActionTypes.RETRIEVE_BENEFITS_CORE.FAIL,
  payload: error,
});

// MealPreselectFlights
export function retrieveMealPreselectFlights() {
  return function action(dispatch) {
    const request = getMealPreselectFlights();

    dispatch(mealPreselectFlightsStart());

    request.then(response => {
      if (response.error) {
        dispatch(mealPreselectFlightsFail(response.error));
      } else {
        dispatch(mealPreselectFlightsSuccess(response));
      }
    }).catch(error => {
      dispatch(mealPreselectFlightsFail(error));
    });
  };
}

export const mealPreselectFlightsStart = () => ({
  type: asyncActionTypes.RETRIEVE_MEALPRESELECT_FLIGHTS.START,
});

export const mealPreselectFlightsSuccess = (response) => ({
  type: asyncActionTypes.RETRIEVE_MEALPRESELECT_FLIGHTS.SUCCESS,
  payload: response,
});

export const mealPreselectFlightsFail = (error) => ({
  type: asyncActionTypes.RETRIEVE_MEALPRESELECT_FLIGHTS.FAIL,
  payload: error,
});

export function setBillingDataAction(BillingData) {
  return function action(dispatch) {
    dispatch(setBillingDataStart());
    try {
      dispatch(setBillingDataSuccess(BillingData));
    } catch (error) {
      dispatch(setBillingDataFail(error));
    }
  };
}

export const setBillingDataStart = () => ({
  type: asyncActionTypes.SET_BILLING_DATA.START,
});

export const setBillingDataSuccess = (response) => ({
  type: asyncActionTypes.SET_BILLING_DATA.SUCCESS,
  payload: response,
});

export const setBillingDataFail = (error) => ({
  type: asyncActionTypes.SET_BILLING_DATA.FAIL,
  payload: error,
});

// Billing
export const getSingleBillingStart = () => ({
  type: asyncActionTypes.GET_SINGLE_BILLING.START,
});

export const getSingleBillingSuccess = (response) => ({
  type: asyncActionTypes.GET_SINGLE_BILLING.SUCCESS,
  payload: response,
});

export const getSingleBillingFail = (error) => ({
  type: asyncActionTypes.GET_SINGLE_BILLING.FAIL,
  error: error,
});

export function getSingleBillingAction(pnr, transactionId) {
  return function action(dispatch) {
    const request = getSingleBilling(pnr, transactionId);
    dispatch(getSingleBillingStart());

    request.then(response => {
      if (response.event === 'error' || response.length === 0) {
        dispatch(getSingleBillingFail(response));
      } else {
        dispatch(getSingleBillingSuccess(response));
      }
    }).catch(error => {
      dispatch(getSingleBillingFail(error));
    });
  };
}

export const getStampingBillingStart = () => ({
  type: asyncActionTypes.GET_STAMPING_BILLING.START,
});

export const getStampingBillingSuccess = (response) => ({
  type: asyncActionTypes.GET_STAMPING_BILLING.SUCCESS,
  payload: response,
});

export const getStampingBillingFail = (error) => ({
  type: asyncActionTypes.GET_STAMPING_BILLING.FAIL,
  error: error,
});

export function getStampingBillingAction(billingData) {
  return function action(dispatch) {
    const request = getStampingBilling(billingData);
    dispatch(getStampingBillingStart());

    request.then(response => {
      if (response.event === 'error' || response.actionable === 'ABORT') {
        dispatch(getStampingBillingFail(response));
      } else {
        dispatch(getStampingBillingSuccess(response));
      }
    }).catch(error => {
      dispatch(getStampingBillingFail(error));
    });
  };
}

// /tc/reservation/pnr
export const getCheckInReservationStart = () => ({
  type: asyncActionTypes.RETRIEVE_CHECKIN_RESERVATION.START,
});

export const getCheckInReservationSuccess = (response) => ({
  type: asyncActionTypes.RETRIEVE_CHECKIN_RESERVATION.SUCCESS,
  payload: response,
});

export const getCheckInReservationFail = (error) => ({
  type: asyncActionTypes.RETRIEVE_CHECKIN_RESERVATION.FAIL,
  payload: error,
});

export function getCheckInReservationAction(pnr, lastname) {
  return function action(dispatch) {
    dispatch(getCheckInReservationStart());
    const request = getCheckInReservation(pnr, lastname);

    request.then(response => {
      if (response.event === 'error') {
        dispatch(getCheckInReservationFail(response?.error));
      } else {
        dispatch(getCheckInReservationSuccess(response));
      }
    }).catch(error => {
      dispatch(getCheckInReservationFail(error));
    });
  };
}
